/**=========================================================
 * Module: qai.js
 * AI Controller
 =========================================================*/

 App.controller('QaiController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'DataService', 'LocalRestangular', '$filter', 'toaster',
     function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, D, LR, $filter, toaster) {
         "use strict";

        var itemsLoaded = {};
        $scope.clients = [];

        $scope.pop = function (type, title, text) {
            toaster.pop(type, title, text, 0, 'trustedHtml');
        };

        let fromParentEntity = !!$scope.parentEntity
        let processId = $scope.parentEntity ? $scope.parentEntity.id.replace('-','') + $scope.idSuffix : $state.params.filter

         let unwatch = $rootScope.$watch('user.id', function(){  
             if($rootScope.user.id){
                 unwatch();
                 $scope.page = {
                     title: 'QAi',
                     subTitle: '' 
                 }

                 $scope.runsById = {}
                 $scope.cleanConditions = function(r){
                    if(r.conditions){
                        for(let i=0;i<r.conditions.length; i++){
                            if(r.conditions[i].key=='unitIds'){
                                r.conditions[0].value=r.conditions[0].value.split(',').filter(elemento => elemento !== '').join(',')
                            }
                        }
                        $scope.runsById[r.id] = r
                        $scope.loadPostProcessResults(r)
                    }else{
                        for(let j=0;j<r.length; j++){
                            for(let i=0;i<r[j].conditions.length; i++){
                                if(r[j].conditions[i].key=='unitIds'){
                                    r[j].conditions[i].value=r[j].conditions[i].value.split(',').filter(elemento => elemento !== '').join(',')
                                }
                            }
                            $scope.runsById[r[j].id] = r[j]
                            $scope.loadPostProcessResults(r[j])
                        }
                    }
                    
                    return r;
                }

                $scope.loadPostProcessResults = function(r){
                    if(r.opts && r.opts.postProcess && r.opts.postProcess.length){
                        for(let i=0; i<r.opts.postProcess.length; i++){
                            let pp = r.opts.postProcess[i]
                            if(pp.result){
                                (function(pp){
                                    if(Array.isArray(pp.result)){
                                        pp.files = []
                                        for(let j=0; j<pp.result.length; j++){
                                            D.load('file', pp.result[j]).then(function(resp){
                                                pp.files.push(resp)
                                            })
                                        }
                                    } else {
                                        D.load('file', pp.result).then(function(resp){
                                            pp.file = resp
                                        })
                                    }
                                })(pp)
                            }
                        }
                    }
                }

                $scope.viewFile = function(){

                    $scope.file = null
                    ngDialog.open({
                        template: '/app/views/entities/file-content.html',
                        className: 'ngdialog-theme-large ngdialog-theme-xxlarge',
                        scope: $scope,
                        cache: false
                    })
                    $scope.folder = "QAi"
                    const f= {
                        "name": "PREPARAZIONE TM PER AI (mqxlz).docx"
                    }
                    LR.one('fs', CONFIG.folderRoot + $scope.folder + CONFIG.folderSeparator + f.name).get()
                        .then(function(result){
                            $scope.file = result
                        }).catch(console.error)
                }

//ADD INSTRUCTION FORM
                $scope.addInstructionFormFn = function(form){
                    return {
                        model: {},
                        fields: [
                            {
                                available: true,
                                type: 'radiowithcontent',
                                name: 'instruction',
                                valueField: 'id',
                                labelField: 'name',
                                required: true,
                                descriptionField: 'question',
                                placeholder: $filter('translate')('labels.QAISELECTINSTRUCTION'),
                                options: $scope.instructions,
                                optionsMap: $scope.instructions.reduce((acc, p) => {
                                    acc[p.id] = p;
                                    return acc;
                                }, {}),
                                onselect: function(option){
                                    $scope.addInstructionForm.model = { instruction: option.id, question: option.question, name: option.name }
                                    for(let i=$scope.addInstructionForm.fields.length-1; i>=0; i--){
                                        let f = $scope.addInstructionForm.fields[i]
                                        if(f.name!='instruction' && f.type!='submit'){
                                            $scope.addInstructionForm.fields.splice(i,1)
                                        }
                                    }
                                    let fields = []
                                    let matches = option.question.match(/\{([^}]+)\}/g)
                                    if(matches){
                                        for(let m of matches){
                                            /*let mj = {}
                                            try{
                                                if(m.indexOf(':')>0){
                                                    mj = JSON.parse(m.split(':', 2)[1].slice(0, -1))
                                                    m = m.split(':', 2)[0] + '}'
                                                }
                                            } catch(e){
                                                mj = {}
                                            }*/
                                            fields.push({
                                                available: true,
                                                required: true,
                                                type: /*mj.type*/ m.toLowerCase().indexOf('lang')>=0 ? 'language' : 'text',
                                                label: /*mj.label ||*/ m,
                                                name: m
                                            })
                                        }
                                    }
                                    $scope.addInstructionForm.fields.splice(1, 0, ...fields)
                                }
                            },
                            {
                                available: true,
                                type: 'submit',
                                label: 'labels.ADD'
                            }
                        ],
                        validate: function(){
                            var errors = [];
                                for(var j=0; j<this.fields.length; j++){
                                    var field = this.fields[j];
                                    if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                        errors.push({field:field,error:'required'});
                                    }
                                }
                            if(errors.length) {
                                var errorMessages ="<ul>";
                                for(var i=0; i<errors.length; i++){
                                    var e = errors[i];
                                    errorMessages += "<li>"
                                        +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                        +"</li>";
                                }
                                errorMessages += "</ul>";
                                $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                return false;
                            }
                            else return true;
                        },
                        submit: function(){
                            if(this.validate()){
                                if(!form.model.instructions) form.model.instructions = []
                                $scope.addInstructionForm.model.question = $scope.addInstructionForm.model.question.replace(/〔/g, '{').replace(/〕/g, '}');

                                $scope.addInstructionForm.model.questionText = $scope.addInstructionForm.model.question
                                for(let f in $scope.addInstructionForm.model){
                                    if(f.startsWith('{')){
                                        $scope.addInstructionForm.model.questionText = $scope.addInstructionForm.model.question.replace(new RegExp(f.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), $scope.addInstructionForm.model[f])
                                    }
                                }
                                form.model.instructions.push($scope.addInstructionForm.model)
                                ngDialog.close()
                            }
                        }
                    }
                }

// PROMPTS
                 if($state.params.action=='prompts'){

                    $scope.page.title = 'QAi: ' + $filter('translate')('labels.QAIPROMPTS')

// TABELLA PROMPTS
                    $scope.promptsTable = {
                        title: '',
                        type: 'qaiprompt',
                        includedFields: ['id', 'opts', 'responseFormat', 'scopes'],
                        fields: [
                            {
                                available: true,
                                name: 'enabled',
                                type: 'checkbox',
                                onchange: function(model){
                                    model._status_enabled = 'status-pending';
                                    model.action = 'ToggleQAiPromptEnabled'
                                    D.save('qaiprompt', model).then(function(response){
                                        D.load('qaiprompt', model.id).then(function(response){
                                            model._status_enabled = '';
                                            model.enabled = response.enabled;
                                            model.action = null
                                        });
                                    }).catch(function(err){
                                        model.action = null
                                        model._status_enabled = 'status-error';
                                        model.enabled = !model.enabled;
                                        D.load('qaiprompt', model.id).then(function(response){
                                            model.enabled = response.enabled;
                                        }).catch(console.error);

                                    });
                                }
                            },
                            {
                                available: true,
                                name: 'name',
                                type: 'click',
                                valueAsLabel: true,
                                onclick: function(m){
                                    $scope.showTestPromptForm = false
                                    $scope.showPromptForm = true
                                    $scope.promptForm = $scope.promptFormFn(m)
                                }
                            },
                            {
                                available: true,
                                name: 'answerType',
                                type: 'enum',
                                enumType: 'qaiType'
                            },{
                                available: true,
                                name: 'question',
                                type: 'hover',
                                icon: 'aqi-ai-prompt'
                            },{
                                available: true,
                                name: 'draft',
                                type: 'boolean'
                            },{
                                available: true,
                                name: 'testPrompt',
                                noLabel: true,
                                iconTooltip: 'labels.QAIPROMPTTEST',
                                isButton: true,
                                type: 'click',
                                icon: 'aqi-action-play',
                                buttonClass: 'btn-xs',
                                condition: function(m){ return m.answerType!='INSTRUCTION' },
                                onclick: function(m){
                                    $scope.showTestPromptForm = true
                                    $scope.showPromptForm = false
                                    $scope.testPromptForm = $scope.testPromptFormFn(m)
                                }
                            },{
                                available: true,
                                name: 'duplicatePrompt',
                                noLabel: true,
                                iconTooltip: 'labels.QAIPROMPTDUPLICATE',
                                isButton: true,
                                type: 'click',
                                icon: 'aqi-action-clone',
                                buttonClass: 'btn-xs',
                                onclick: function(m){
                                    D.load('qaiprompt', m.id).then(function(response){
                                        $scope.showTestPromptForm = false
                                        $scope.showPromptForm = true
                                        response.id = null
                                        response.draft = true
                                        $scope.promptForm = $scope.promptFormFn(response)
                                    })
                                }
                            }
                        ],
                        links: [
                            {
                                label: 'labels.QAIPROMPTADDNEW',
                                cmd: function(){
                                    $scope.showPromptForm = true
                                    $scope.showTestPromptForm = false
                                    $scope.promptForm = $scope.promptFormFn({draft:true})
                                }
                            }
                        ]
                    }

                    D.query('qaimodel','').then(function(response){
                        $scope.models = response;
                    })



//TEST PROMPT FORM
                    $scope.showTestPromptForm = false
                    $scope.qaiModelCanReasoningEffort = false;
                    $scope.testPromptFormFn = function(m){
                        $scope.testingPrompt = m
                        $scope.testingPrompt.opts = typeof m.opts === 'string' ? JSON.parse(m.opts || '{}') : m.opts
                        $scope.testingPrompt.responseFormat = typeof m.responseFormat === 'string' ? JSON.parse(m.responseFormat || '{}') : m.responseFormat
                        m.testOpts = typeof m.opts === 'object' && m.opts!=null ? JSON.stringify(m.opts, null, 4) : m.opts
                        m.testResponseFormat = typeof m.responseFormat === 'object' && m.responseFormat!=null ? JSON.stringify(m.responseFormat, null, 4) : m.responseFormat
                        
                        let fields = []
                        let matches = m.question.match(/\{([^}]+)\}/g)
                        let addedM = []
                        for(let m of matches){
                            let mm = m.split('+')[0]
                            if(!mm.endsWith('}')) mm += '}'
                            if(addedM.indexOf(mm)<0){
                                addedM.push(mm)
                                fields.push({
                                    available: true,
                                    type: 'text',
                                    label: mm,
                                    name: mm
                                })
                            }
                        }
                        return {
                            title: 'labels.QAIPROMPTTEST',
                            titleParams: {
                                promptName: m.name
                            },
                            status: '',
                            type: 'qaiprompt',
                            model: { prompt: m.id, question: m.question, testOpts: m.testOpts, testResponseFormat: m.testResponseFormat },
                            fields: [
                                
                                {
                                    available: true,
                                    type: 'textarea',
                                    name: 'question',
                                    required: true,
                                    rows:10
                                },{
                                    available: true,
                                    type: 'textarea',
                                    name: 'testOpts',
                                    label: 'fields.OPTIONS',
                                    rows: 3
                                },{
                                    available: true,
                                    type: 'textarea',
                                    name: 'testResponseFormat',
                                    label: 'fields.RESPONSEFORMAT',
                                    rows: 3
                                }]
                                .concat(fields)
                                .concat([{
                                    available: true,
                                    type: 'addelements',
                                    name: 'instructions',
                                    elementLabelField: 'questionText',
                                    onadd: function(event){
                                        event.preventDefault();
                                        $scope.instructions = $scope.promptsTable.data.filter((p) => p.answerType=='INSTRUCTION')
                                        $scope.addInstructionForm = $scope.addInstructionFormFn($scope.testPromptForm)
                                        
                                        ngDialog.open({
                                            template: '/app/views/entities/qai-instruction.html',
                                            className: 'ngdialog-theme-default ngdialog-theme-large',
                                            scope: $scope
                                        })
                                    },
                                    onremove: function(index, element){
                                        $scope.testPromptForm.model.instructions.splice(index,1)
                                    }
                                },
                                {
                                    available: true,
                                    type: 'select',
                                    name: 'model',
                                    label: 'fields.QAIMODEL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.models && $scope.models.filter(m => m.enabled),
                                    onchange: function(option){
                                        $scope.qaiModelCanReasoningEffort = false;
                                        for(var i=0; i<$scope.models.length; i++){
                                            var qaiModel = $scope.models[i];
                                            if($scope.testPromptForm.model.model == qaiModel.id && qaiModel.canReasoningEffort && qaiModel.canReasoningEffort!=null){
                                                $scope.qaiModelCanReasoningEffort = true;
                                                for(var j=0; j<$scope.testPromptForm.fields.length; j++){
                                                    var field = $scope.testPromptForm.fields[j];
                                                    if(field.name == 'reasoningEffort'){
                                                        field.available = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },{
                                    available: $scope.qaiModelCanReasoningEffort,
                                    type: 'select',
                                    name: 'reasoningEffort',
                                    data: [
                                        { id: 'low', name: 'low' },
                                        { id: 'medium', name: 'medium' },
                                        { id: 'high', name: 'high' }
                                    ],
                                    valueField: 'id',
                                    labelField: 'name'
                                },{
                                    available: true,
                                    type: 'submit'
                                }])
                            ,
                            submit: function(){
                                $scope.testPromptForm.status = 'submitting'
                                D.save('qairesult', Object.assign($scope.testPromptForm.model, {action:'TestQAiPrompt'})).then(function(response){
                                    $scope.testPromptForm.status = 'submitted'
                                    $scope.testPromptResult = response
                                    $scope.testPromptResult.entry = JSON.parse(response.entry || '{}')
                                }).catch(function(err){
                                    $scope.testPromptForm.status = 'error'
                                })
                            }
                        }
                    }
                    
// ADD OR EDIT PROMPT FORM
                    $scope.showPromptForm = false
                    $scope.promptFormFn = function(model){ 
                        if(!model) return
                        model.opts = typeof model.opts === 'object' ? JSON.stringify(model.opts, null, 4) : model.opts
                        model.responseFormat = typeof model.responseFormat === 'object' ? JSON.stringify(model.responseFormat, null, 4) : model.responseFormat
                        return {
                            title: model.id ? (model.draft ? 'labels.QAIPROMPTEDIT' : 'labels.QAIPROMPT') : 'labels.QAIPROMPTADDNEW',
                            isEdit: model.id ? true : false,
                            status: '',
                            type: 'qaiprompt',
                            model: model || { },
                            fields: [
                                {
                                    available: true,
                                    type: model.draft ? 'text' : 'static',
                                    name: 'name',
                                    required: true
                                },
                                {
                                    available: true,
                                    type: model.draft ? 'textarea' : 'staticFormatted',
                                    name: 'question',
                                    required: true,
                                    rows: model.question ? model.question.split('\n').length + 5 : 15
                                },{
                                    available: true,
                                    type: model.draft ? 'select' : 'static',
                                    name: 'answerType',
                                    data: [
                                        { id: 'RATING', name: $filter('translate')('enums.qaiType.RATING') },
                                        { id: 'COMMENT', name: $filter('translate')('enums.qaiType.COMMENT') },
                                        { id: 'INSTRUCTION', name: $filter('translate')('enums.qaiType.INSTRUCTION') },
                                        { id: 'ELABORATION', name: $filter('translate')('enums.qaiType.ELABORATION') },
                                        { id: 'EMBEDDINGS', name: $filter('translate')('enums.qaiType.EMBEDDINGS') },
                                        { id: 'STRUCTURED', name: $filter('translate')('enums.qaiType.STRUCTURED') },
                                        { id: 'BOOLEAN', name: $filter('translate')('enums.qaiType.BOOLEAN') }
                                    ],
                                    valueField: 'id',
                                    labelField: 'name',
                                    required: true,
                                    onchange: function(option) {
                                        $scope.promptForm.fields.find(f => f.name=='responseFormat').available = $scope.promptForm.model.answerType === 'STRUCTURED' || $scope.promptForm.model.answerType === 'INSTRUCTION';
                                        if($scope.promptForm.model.answerType === 'STRUCTURED' || $scope.promptForm.model.answerType === 'INSTRUCTION'){
                                            $scope.promptForm.model.responseFormat=JSON.stringify({
                                                "json_schema": {
                                                    "schema": {
                                                        "additionalProperties": false,
                                                        "type": "object",
                                                        "required": [
                                                        ],
                                                        "properties": {
                                                        }
                                                    },
                                                    "name": "prompt_response_format",
                                                    "strict": true
                                                },
                                                "type": "json_schema"
                                            }, null, 4)
                                        }else{
                                                $scope.promptForm.model.responseFormat='{}';
                                        }
                                        
                                    },
                                    display: {
                                        type: 'enum',
                                        enumType: 'qaiType'
                                    }
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'scopes'
                                },
                                {
                                    available: true,
                                    name: 'draft',
                                    type: model.draft ? 'checkbox' : 'static',
                                    required: true,
                                    display: {
                                        type: 'boolean'
                                    }
                                },
                                {
                                    available: true,
                                    type: model.draft ? 'jsoneditor' : 'staticFormatted',
                                    name: 'opts',
                                    label: 'fields.OPTIONS',
                                    rows: model.opts ? model.opts.split('\n').length + 5 : 20,
                                    commands: [
                                        { title: 'Add PostProcess procedure', action: 'addToArray', icon: 'aqi-plus', label: 'PP', params: { arrayName: 'postProcess'}, fields: [{ available: true, name: 'name', type: 'simpleselect', label: 'name', data: ['RewriteXliff','BenchmarkRating','CompareRatings','ExtractCosts','ExtractQuestions','ExtractSystemFingerprints','ExtractWords','ExtractTerms','ExtractFiltered'] },{available:true, name:'title', type: 'text', label: 'title'}] },
                                        { title: 'Remove PostProcess procedure', action: 'removeFromArray', icon: 'aqi-minus', label: 'PP', params: { arrayName: 'postProcess', fieldName: 'name'}, fields: [{ available: true, name: 'name', type: 'simpleselect', label: 'name', data: ['RewriteXliff','BenchmarkRating','CompareRatings','ExtractCosts','ExtractQuestions','ExtractSystemFingerprints','ExtractWords','ExtractTerms','ExtractFiltered'] }] },
                                        { title: 'Add PostProcess param', action: 'setFieldInArray', icon: 'aqi-plus', params: { arrayName: 'postProcess', keyField: 'name'}, fields: [{available: true, name:'name', type:'text',label:'PostProcess name'}, {available:true, name: 'fieldName', type:'text', label: 'field name'}, {available: true, name:'value', type:'text',label:'value'}], model: { fieldName: 'params.'} },
                                        { title: 'Remove PostProcess param', action: 'removeFieldInArray', icon: 'aqi-minus', params: { arrayName: 'postProcess', keyField: 'name'}, fields: [{available: true, name:'name', type:'text',label:'PostProcess name'}, {available:true, name: 'fieldName', type:'text', label: 'field name'}], model: { fieldName: 'params.'} },
                                        { title: 'Add check', action: 'addToArray', icon: 'aqi-plus', label: 'Ch', params: { arrayName: 'checks'}, fields: [{ available: true, name: 'name', type: 'select', label: 'name', data: [{n:'ContentIsTerm'}], valueField:'n', labelField:'n' },{available:true, name:'defaultResponse', type: 'text', label: 'default response'}] },
                                        { title: 'Remove check', action: 'removeFromArray', icon: 'aqi-minus', label: 'Ch', params: { arrayName: 'checks', fieldName:'name'}, fields: [{ available: true, name: 'name', type: 'select', label: 'name', data: [{n:'ContentIsTerm'}], valueField:'n', labelField:'n' }] },
                                        { title: 'Add content field', action: 'setField', icon: 'aqi-plus', label: 'CF', params: { fieldName: 'contentField' }, fields: [{ available: true, name: 'contentField', type: 'text', label: 'Content field' }] },
                                        { title: 'Remove content field', action: 'removeField', icon: 'aqi-minus', label: 'CF', params: { fieldName: 'contentField' } },
                                        { title: 'Add elaborate action', action: 'setField', icon: 'aqi-plus', label: 'Ac', params: { fieldName: 'action' }, fields: [{ available: true, name: 'action', type: 'select', label: 'Elaborate action', data: [{name:'AssignTermsToEntry'},{name:'FindSimilarEntries'}], valueField: 'name', labelField:'name' }] },
                                        { title: 'Remove elaborate action', action: 'removeField', icon: 'aqi-minus', label: 'Ac', params: { fieldName: 'action' } },
                                        { title: 'Add additional output field', action: 'addToArray', icon: 'aqi-plus', label: 'AO', params: { arrayName: 'additionalOutput'}, fields: [{ available: true, name: 'name', type: 'text', label: 'name' },{available:true, name:'after', type: 'text', label: 'after field'},{available:true, name:'dataSource', label:'data source',type:'simpleselect',data:['response','entry']}] },
                                        { title: 'Remove additional output field', action: 'removeFromArray', icon: 'aqi-minus', label: 'AO', params: { arrayName: 'additionalOutput', fieldName: 'name'}, fields: [{ available: true, name: 'name', type: 'text', label: 'name' }] },
                                        { title: 'Add compute response', action: 'setField', icon: 'aqi-plus', label: 'CR', params: { fieldName: 'computeResponse'}, fields: [{ available: true, name: 'name', type: 'simpleselect', label: 'name', data: ['SynthesizeMultiRating','AfterSourceCompare'], valueField:'n', labelField:'n' }] },
                                        { title: 'Remove compute response', action: 'removeField', icon: 'aqi-minus', label: 'CR', params: { fieldName: 'computeResponse' } },
                                        { title: 'Add condition', action: 'addToArray', icon: 'aqi-plus', params: { arrayName: 'conditions'}, fields: [{ available: true, name: 'key', type: 'simpleselect', label: 'condition type', data: ['rating','boolean','entryHas','mqOptions']},{available:true, name:'value', type: 'text', label: 'value'}] },
                                        { title: 'Remove condition', action: 'removeFromArray', icon: 'aqi-minus', params: { arrayName: 'conditions', fieldName:'key'}, fields: [{ available: true, name: 'key', type: 'text', label: 'condition type' }] },
                                        { title: 'Set Can be batched', action: 'setField', icon: 'aqi-action-edit', params: { fieldName: 'canBeBatched' }, fields: [{ available: true, name: 'canBeBatched', type: 'switch', options:[{value:true,label:'Y'},{value:false,label:'N'}], label: 'Run in batch enabled' }] },
                                        { title: 'Set Highlight output differences', action: 'setField', icon: 'aqi-action-edit', params: { fieldName: 'highlighted' }, fields: [{ available: true, name: 'highlighted', type: 'switch', options:[{value:true,label:'Y'},{value:false,label:'N'}], label: 'Highlight output differences' }] }
                                        
                                    ]
                                },
                                {
                                    available: model.answerType === 'STRUCTURED' || model.answerType === 'INSTRUCTION',
                                    type: model.draft ? 'jsoneditor' : 'staticFormatted',
                                    withInstructions: model.draft,
                                    name: 'responseFormat',
                                    rows: model.responseFormat ? model.responseFormat.split('\n').length + 5 : 25,
                                    commands: [
                                        { title: 'Set name', action: 'setField', icon: 'aqi-action-edit', label: 'Name', params: { fieldName: 'json_schema.name' }, fields: [{ available: true, name: 'name', type: 'text', label: 'name' }] },
                                        { title: 'Add property', action: 'addJsonSchemaProperty', icon: 'aqi-plus', label: 'Property', 
                                            fields: [{available: true, name: 'name', type:'text', label: 'name'},
                                                     {available: true, name: 'type', type:'simpleselect', data: ['string','number','boolean','array','object','null'],label:'type'},
                                                     {available: true, name: 'description', type:'text',label:'descrpition'},
                                                     {available: true, name: 'items.type', type:'simpleselect', data: ['string','number','boolean'],label:'if array, items type'},
                                                     {available: true, name: 'items.$ref', type:'text',label:'if array, items ref'},
                                            ] },
                                        { title: 'Remove property', action: 'removeJsonSchemaProperty', icon: 'aqi-minus', label: 'Property', fields: [{available: true, name: 'name', type:'text', label: 'name'}] },
                                        { title: 'Add $def property', action: 'addJsonSchemaDefsProperty', icon: 'aqi-plus', label: '$defs Property', fields: [
                                            {available: true, name: '$def', type:'text', label: 'def name'},
                                            {available: true, name: 'name', type:'text', label: 'name'},
                                            {available: true, name: 'type', type:'simpleselect', data: ['string','number','boolean','array','object','null'],label:'type'},
                                            {available: true, name: 'description', type:'text',label:'descrpition'},
                                            {available: true, name: 'items.type', type:'simpleselect', data: ['string','number','boolean'],label:'if array, items type'},
                                            {available: true, name: 'items.$ref', type:'text',label:'if array, items ref'},
                                        ]},
                                        { title: 'Remove $def property', action: 'removeJsonSchemaDefsProperty', icon: 'aqi-minus', label: '$defs Property', fields: [{available: true, name: '$def', type:'text', label: 'def name'},{available: true, name: 'name', type:'text', label: 'name'}] },
                                        
                                    ]
                                },
                                {
                                    available: model.draft,
                                    type: 'submit'
                                }
                            ],
                            validate: function(){
                                var errors = [];
                                    for(var j=0; j<this.fields.length; j++){
                                        var field = this.fields[j];
                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                            errors.push({field:field,error:'required'});
                                        }
                                    }
                                if(errors.length) {
                                    var errorMessages ="<ul>";
                                    for(var i=0; i<errors.length; i++){
                                        var e = errors[i];
                                        errorMessages += "<li>"
                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                            +"</li>";
                                    }
                                    errorMessages += "</ul>";
                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    return false;
                                }
                                else return true;
                            },
                            submit: function(){
                                if(this.validate()){
                                    $scope.promptForm.status = 'submitting'
                                    D.save('qaiprompt', $scope.promptForm.model).then(function(response){
                                        $scope.promptForm.status = 'submitted'
                                        if(!$scope.promptForm.isEdit){
                                            $scope.promptsTable.data.push(response)
                                        }
                                        $scope.promptForm.model = { }
                                        $scope.promptForm = $scope.promptFormFn({draft:true})
                                    }).catch(function(err){
                                        $scope.promptForm.status = 'error'
                                    })
                                }
                            }
                        }
                    }
                    $scope.promptForm = $scope.promptFormFn()
                 }

// MODELS
                 if($state.params.action=='models'){

                    $scope.page.title = 'QAi: ' + $filter('translate')('labels.QAIMODELS')
// MODELS TABLE
                    $scope.modelsTable = {
                        title: '',
                        type: 'qaimodel',
                        includedFields: ['id'],
                        fields: [
                            {
                                available: true,
                                name: 'enabled',
                                type: 'boolean'
                            },
                            {
                                available: true,
                                name: 'name'
                            },{
                                available: true,
                                name: 'type'
                            },{
                                available: true,
                                name: 'isDefault',
                                type: 'boolean'
                            },{
                                available: true,
                                name: 'isDefaultSC',
                                type: 'boolean'
                            },{
                                available: true,
                                name: 'editModel',
                                noLabel: true,
                                iconTooltip: 'labels.QAIMODELEDIT',
                                isButton: true,
                                type: 'click',
                                icon: 'aqi-action-edit',
                                buttonClass: 'btn-xs',
                                onclick: function(m){
                                    D.load('qaimodel', m.id).then(function(response){
                                        $scope.modelForm = $scope.modelFormFn(response)
                                    })
                                }
                            },{
                                available: true,
                                name: 'fineTuning',
                                noLabel: true,
                                iconTooltip: 'labels.QAIMODELFINETUNING',
                                isButton: true,
                                type: 'click',
                                icon: 'aqi-status-revision',
                                buttonClass: 'btn-xs',
                                onclick: function(m){
                                    D.load('qaimodel', m.id).then(function(response){
                                        $scope.modelForm = $scope.fineTuningFormFn(response)
                                    })
                                }
                            }
                        ],
                        links: [
                            {
                                label: 'labels.QAIMODELADDNEW',
                                cmd: function(){
                                    $scope.modelForm = $scope.modelFormFn({})
                                }
                            }
                        ]
                    }
//MODELS FORM
                    $scope.modelFormFn = function(model){
                        return {
                            title: model.id ? 'labels.QAIMODELEDIT' : 'labels.QAIMODELADDNEW',
                            status: '',
                            type: 'qaimodel',
                            model: model || {},
                            fields: [
                                {
                                    available: true,
                                    type: model.id ? 'static' : 'text',
                                    name: 'name',
                                    required: true
                                },{
                                    available: true,
                                    name: 'enabled',
                                    type: 'checkbox'
                                },{
                                    available: true,
                                    type: 'select',
                                    name: 'type',
                                    data: [
                                        { id: 'OpenAi', name: 'OpenAi' },
                                        { id: '(mock)', name: '(mock)' },
                                    ],
                                    valueField: 'id',
                                    labelField: 'name',
                                    required: true
                                },{
                                    available: true,
                                    type: 'select',
                                    name: 'subType',
                                    data: [
                                        { id: '', name: '-'},
                                        { id: 'embedding', name: 'embedding'}
                                    ],
                                    valueField: 'id',
                                    labelField: 'name'
                                },{
                                    available: true,
                                    type: 'currency',
                                    name: 'priceInput',
                                    type: 'decimal',
                                    displayType: 'decimal',
                                    decimalSep: $rootScope.user.decimalSep,
                                    decimals: 3,
                                    labelParams: { currency: 'USD'},
                                    postfix: $filter('translate')('enums.currencySymbol.USD')
                                },{
                                    available: true,
                                    name: 'priceOutput',
                                    type: 'decimal',
                                    displayType: 'decimal',
                                    decimalSep: $rootScope.user.decimalSep,
                                    decimals: 3,
                                    labelParams: { currency: 'USD'},
                                    postfix: $filter('translate')('enums.currencySymbol.USD')
                                },{
                                    available: true,
                                    type: 'currency',
                                    name: 'priceBatchInput',
                                    type: 'decimal',
                                    displayType: 'decimal',
                                    decimalSep: $rootScope.user.decimalSep,
                                    decimals: 3,
                                    labelParams: { currency: 'USD'},
                                    postfix: $filter('translate')('enums.currencySymbol.USD')
                                },{
                                    available: true,
                                    type: 'currency',
                                    name: 'priceBatchOutput',
                                    type: 'decimal',
                                    displayType: 'decimal',
                                    decimalSep: $rootScope.user.decimalSep,
                                    decimals: 3,
                                    labelParams: { currency: 'USD'},
                                    postfix: $filter('translate')('enums.currencySymbol.USD')
                                },{
                                    available: true,
                                    name: 'settings',
                                    type: 'textarea'
                                },{
                                    available: true,
                                    name: 'isDefault',
                                    type: 'checkbox'
                                },{
                                    available: true,
                                    name: 'isDefaultSC',
                                    type: 'checkbox'
                                },{
                                    available: true,
                                    name: 'canReasoningEffort',
                                    type: 'checkbox'
                                },
                                {
                                    available: true,
                                    type: 'submit'
                                }
                            ],
                            validate: function(){
                                var errors = [];
                                if((this.model.isDefault || this.model.isDefaultSC) && !this.model.enabled){
                                    errors.push({field:this.fields[1],error:'DEFAULTMODELCANTBEDISABLED'});
                                }
                                for(var j=0; j<this.fields.length; j++){
                                    var field = this.fields[j];
                                    if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                        errors.push({field:field,error:'required'});
                                    }
                                }
                                if(errors.length) {
                                    var errorMessages ="<ul>";
                                    for(var i=0; i<errors.length; i++){
                                        var e = errors[i];
                                        var fieldName = (e.field.label && e.field.label.trim() !== '') ? e.field.label.replace('fields.','') : e.field.name;
                                        errorMessages += "<li>"
                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+fieldName.toUpperCase()) })
                                            +"</li>";
                                    }
                                    errorMessages += "</ul>";
                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    return false;
                                }
                                else return true;
                            },
                            submit: function(){
                                if(this.validate()){
                                    const updatedModel = $scope.modelForm.model;
                                    $scope.modelForm.status = 'submitting'
                                    D.save('qaimodel', $scope.modelForm.model).then(function(response){
                                        $scope.modelForm.status = 'submitted'
                                        //Update isDefault or isDefaultSC values in modelsTable
                                        const modelIndex = $scope.modelsTable.data.findIndex(m => m.id === updatedModel.id);
                                        if (modelIndex !== -1) {
                                            $scope.modelsTable.data[modelIndex].isDefault = updatedModel.isDefault;
                                            $scope.modelsTable.data[modelIndex].isDefaultSC = updatedModel.isDefaultSC;
                                            $scope.modelsTable.data[modelIndex].enabled = updatedModel.enabled;
                                        }
                                    })
                                }
                            }
                        }
                    }
                    
                    $scope.fineTuningFormFn = function(model){
                        return {
                            title: 'labels.QAIMODELFINETUNING',
                            status: '',
                            type: 'qaimodel',
                            model: model || {},
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'finetuneupload',
                                    canUpload: true,
                                    limit: 1,
                                    bucket: $rootScope.bucketName(),
                                    filesSelectable: $rootScope.user.admin
                                },
                                {
                                    available: true,
                                    type: 'multisubmit',
                                    noLabel: true,
                                    actions: [
                                        { 
                                            label: 'labels.UPLOADTOOPENAI',
                                            model: { action: 'QAiModelUploadToOpenAi', purpose: 'fine-tune' }
                                        }
                                    ]
                                },{
                                    available: true,
                                    type: 'file',
                                    name: 'finetuneuploaded',
                                    canUpload: false
                                },{
                                    available: true,
                                    type: 'text',
                                    name: 'suffix',
                                    label: 'fields.NAME'
                                },{
                                    available: true,
                                    type: 'multisubmit',
                                    noLabel: true,
                                    actions: [
                                        { 
                                            label: 'labels.QAIFINETUNE',
                                            model: { action: 'QAiModelFineTune' }
                                        }
                                    ]
                                }
                            ],
                            submit: function(){
                                $scope.modelForm.status = 'submitting'
                                D.save('qaimodel', $scope.modelForm.model).then(function(response){
                                    if(response.id!=$scope.modelForm.model.id){ $window.location.reload() }
                                    $scope.modelForm = $scope.fineTuningFormFn(response)
                                    $scope.modelForm.status = 'submitted'
                                })
                            }
                        }
                    }
                 }

//
//PROCESS
//
                if($state.params.action=='process' || $state.params.action=='edittitle' || $state.params.action=='delete' || fromParentEntity){

                    $scope.isActiveTab = function(i){
                        return $scope.activeTab == i;
                    }
                    $scope.setActiveTab = function(i){
                        $scope.activeTab = i;
                    }

                    $scope.loadTermFiles = function(cb){
                        D.query('file', 'type=GROUP&field=qaiTerms&status=imported&entityid=' + $scope.process.client).then(function(response){
                            $scope.termFiles = response
                            if($scope.newRunForm){
                                $scope.newRunForm.fields.find(f => f.name=='termFiles').data = response
                            }
                            if(cb) cb(response)
                        })
                    }

                    D.load('qaiprocess', processId).then(function(response){
                        $scope.process = response;
                        if(!response.id && fromParentEntity){ 
                            $scope.process = {
                                id: processId,
                                files: {},
                                status: null,
                                client: $scope.parentEntity.group,
                                T: new Date().getTime()
                            } 
                        }
                        $scope.page.title = 'QAi: ' + response.name;

                        if($scope.process.status=='INSERTED'){
                            $scope.activeTab = 0
                        }
                        if($scope.process.status=='IMPORTING' || $scope.process.status=='IMPORTED'){
                            $scope.activeTab = 1
                        }

                        $scope.summaryForm = {
                            title: '',
                            status: '',
                            type: 'qaiprocess',
                            model: $scope.process,
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'final',
                                    noLabel: true,
                                    limit: -1,
                                    canUpload: true,
                                    bucket: $rootScope.bucketName($scope.process.client),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },{
                                    available: true,
                                    type: $scope.process.notes ? 'staticFormatted' : 'textarea',
                                    name: 'notes',
                                    toggle: function(){
                                        let f = $scope.summaryForm.fields.find(f => f.name=='notes')
                                        f.type = f.type=='staticFormatted' ? 'textarea' : 'staticFormatted'
                                    },
                                    withSave: true,
                                    onsave: function(event, form){
                                        event.preventDefault();
                                        D.save('qaiprocess', {id: $scope.process.id, action: 'SaveQAiProcessNotes', notes: $scope.summaryForm.model.notes}).then(function(response){
                                            $scope.summaryForm.fields.find(f => f.name=='notes').toggle()
                                        })
                                    }
                                }
                            ]
                        }

                        $scope.initNotificationForm = function(){
                            $scope.notificationForm = {
                                title: '',
                                status: '',
                                type: 'qaiprocess',
                                model: $scope.process,
                                fields: [
                                    {
                                        available: true,
                                        type: 'switch',
                                        noLabel: true,
                                        name: 'mailNotificationWanted',
                                        disabled: false,
                                        loading: false,
                                        buttonsXs: true,
                                        options: [{
                                            value: true,
                                            label: 'labels.MAILNOTIFICATIONSACTIVE'
                                        }, {
                                            value: false,
                                            label: 'labels.MAILNOTIFICATIONSNOTACTIVE'
                                        }],
                                        onchange: function(option){
                                            if(option.value != $scope.process.mailNotificationWanted){
                                                $scope.notificationForm.fields[0].disabled = true
                                                $scope.notificationForm.fields[0].loading = true
                                                D.save('qaiprocess', {id: $scope.process.id, action: 'SaveMailNotificationWanted', mailNotificationWanted: option.value}).then(function(response){
                                                    $scope.process = response;
                                                    $scope.initNotificationForm();
                                                })
                                                
                                            }
                                        }
                                    }
                                ]
                            }
                        }

                        $scope.initNotificationForm();

                        FIREBASE.listen('QAiProcess', $scope.process.id, function(value){
                            if(value && FIREBASE.isAfter(value.timestamp,$scope.process.T)){
                                $timeout(function(){
                                D.load('qaiprocess', $scope.process.id).then(function(response){
                                    let files = $scope.process.files || {}
                                    for(let k in response.files){
                                        if(!files[k] || !files[k].rtUpdate){
                                            files[k] = response.files[k]
                                        }
                                    }
                                    response.files = files
                                    $scope.process = response;
                                    if($scope.process.status=='IMPORTED'){
                                        $scope.initEntriesTable()
                                    }
                                })
                                }, 0)
                            }
                        }, null, { interval: 10000 })

                        $scope.$watch('process.status', function(newValue, oldValue) {
                            if (newValue === 'IMPORTING' && $scope.parentEntity){
                                for(let key in $scope.process.files){
                                    listenFile(key)
                                }
                            }
                            if(newValue=='RUNNING' && $scope.parentEntity){
                                D.query('qairun', 'process=' + $scope.process.id).then(function(response){
                                    $scope.runs = $scope.cleanConditions(response);
                                    $scope.lastRun = $scope.runs[$scope.runs.length-1]
                                    $scope.listenRun($scope.lastRun.id)
                                    $scope.postProcessResultFormFn($scope.lastRun.id)
                                })
                            }
                            if (newValue === 'COMPLETED') {
                                if($scope.runs && $scope.runs.length){
                                    $scope.showRunResultsTableClick($scope.runs[$scope.runs.length-1].id)
                                    $scope.lastRun = $scope.runs[$scope.runs.length-1]
                                    $scope.postProcessResultFormFn($scope.lastRun.id)
                                } else {
                                    D.query('qairun', 'process=' + $scope.process.id).then(function(response){
                                        $scope.runs = $scope.cleanConditions(response);
                                        $scope.showRunResultsTableClick($scope.runs[$scope.runs.length-1].id)
                                        $scope.lastRun = $scope.runs[$scope.runs.length-1]
                                        $scope.postProcessResultFormFn($scope.lastRun.id)
                                    })
                                }
                                
                            }
                            if (newValue === 'IMPORTFILERESETTING') {
                                $scope.setActiveTab(0);
                            }
                            if (oldValue === 'IMPORTFILERESETTING') {
                                $scope.resettingImport=false;
                            }
                        });

                        $scope.runResultsTable = {}
                        $scope.showRunResultsTable = {}
                        $scope.showRunResultsTableClick = function(runId){
                            $scope.showRunResultsTable[runId]=true
                            $timeout(function(){
                                let r = $scope.runs.filter((r) => r.id==runId)[0]
                                $scope.runResultsTable[runId] = {
                                    title: 'labels.QAIRESULT',
                                    type: 'qairesult',
                                    baseFilter: '_withEntry=true&run=' + runId,
                                    includedFields: ['id','entry'],
                                    commandButtons: [
                                        {
                                            available: true,
                                            cls: 'btn btn-default',
                                            icon: 'aqi-action-refresh',
                                            onclick: function(){
                                                $scope.runResultsTable[runId].reload();
                                            }
                                        }
                                    ],
                                    fields: [
                                        {
                                            available: true,
                                            name: 'unitId'
                                        },
                                        {
                                            available: true,
                                            name: 'source',
                                            type: 'ellipsed'
                                        },
                                        {
                                            available: true,
                                            name: 'target',
                                            type: 'ellipsed'
                                        },
                                        {
                                            available: true,
                                            name: 'question',
                                            type: 'icon',
                                            iconTooltipField: 'question',
                                            icon: 'aqi-ai-prompt'
                                        },
                                        {
                                            available: r.type!='STRUCTURED',
                                            name: 'content',
                                            label: 'QAIRESULTCONTENT',
                                            type: 'ellipsed'
                                        },
                                        {
                                            available: r.type=='STRUCTURED',
                                            name: 'structured',
                                            label: 'QAIRESULTCONTENT',
                                            type: 'hover',
                                            icon: 'aqi-json'
                                        },
                                        {
                                            available: true,
                                            name: 'viewResults',
                                            type: 'click',
                                            noLabel: true,
                                            icon: 'aqi-action-show-more',
                                            buttonClass: 'btn-xs',
                                            onclick: function(m){
                                                $scope.entry = m
                                                D.query('qairesult','entry=' + m.entry).then(function(response){
                                                    $scope.entryResults = response
                                                })
                                                ngDialog.open({
                                                    template: '/app/views/entities/qai-entryresults.html',
                                                    className: 'ngdialog-theme-default ngdialog-theme-large',
                                                    scope: $scope
                                                })
                                            }
                                        }
                                    ]
                                }
                            }, 3000)
                            
                        }

                        $scope.runResultsFiles = {}
                        $scope.runTermsFiles = {}

                        D.query('qairun', 'process=' + $scope.process.id).then(function(response){
                            $scope.runs = $scope.cleanConditions(response);
                            if($scope.runs.length>0) $scope.activeTab = $scope.runs[$scope.runs.length-1].id
                            $scope.runStatuses = {}
                            if($scope.runs[$scope.runs.length-1].status=='RUNNING' && $scope.runs[$scope.runs.length-1].isBatch){
                                D.save('qairun', { id: $scope.runs[$scope.runs.length-1].id, action: 'CheckQAiBatchesProgress' }).then(function(response){
                                    $scope.listenRun($scope.runs[$scope.runs.length-1].id)
                                })
                            }
                            for(let i=0; i<$scope.runs.length; i++){
                                let r = $scope.runs[i]
                                $scope.runStatuses[r.status] = $scope.runStatuses[r.status] ? $scope.runStatuses[r.status]+1 : 1
                                if(r.status=='RUNNING' || r.status=='POSTPROCESSING') $scope.activeTab = r.id
                                D.query('file', 'entityId='+r.id+'&type=QAiRun&field=results&status=GENERATED').then(function(resp){
                                    $scope.runResultsFiles[r.id] = resp
                                })
                                if (!$scope.runTermsFiles[r.id]) {
                                    $scope.runTermsFiles[r.id] = [];
                                }
                                if(r.opts.termFiles && r.opts.termFiles.length>0){
                                    for(let j=0; j<r.opts.termFiles.length; j++){
                                        D.load('file', r.opts.termFiles[j]).then(function(respTerm){
                                            $scope.runTermsFiles[r.id].push(respTerm)
                                        })
                                    }
                                }
                                $scope.runResultsTable[r.id] = {
                                    title: 'labels.QAIRESULT',
                                    type: 'qairesult',
                                    baseFilter: '_withEntry=true&run=' + r.id,
                                    includedFields: ['id','entry'],
                                    commandButtons: [
                                        {
                                            available: true,
                                            cls: 'btn btn-default',
                                            icon: 'aqi-action-refresh',
                                            onclick: function(){
                                                $scope.runResultsTable[r.id].reload();
                                            }
                                        }
                                    ],
                                    fields: [
                                        {
                                            available: true,
                                            name: 'unitId'
                                        },
                                        {
                                            available: true,
                                            name: 'source',
                                            type: 'ellipsed'
                                        },
                                        {
                                            available: true,
                                            name: 'target',
                                            type: 'ellipsed'
                                        },
                                        {
                                            available: true,
                                            name: 'question',
                                            type: 'hover',
                                            icon: 'aqi-ai-prompt'
                                        },
                                        {
                                            available: r.type!='STRUCTURED',
                                            name: 'content',
                                            label: 'QAIRESULTCONTENT',
                                            type: 'ellipsed'
                                        },
                                        {
                                            available: r.type=='STRUCTURED',
                                            name: 'structured',
                                            label: 'QAIRESULTCONTENT',
                                            type: 'hover',
                                            icon: 'aqi-json'
                                        },
                                        {
                                            available: true,
                                            name: 'viewResults',
                                            type: 'click',
                                            noLabel: true,
                                            icon: 'aqi-action-show-more',
                                            buttonClass: 'btn-xs',
                                            onclick: function(m){
                                                $scope.entry = m
                                                D.query('qairesult','entry=' + m.entry).then(function(response){
                                                    $scope.entryResults = response
                                                })
                                                ngDialog.open({
                                                    template: '/app/views/entities/qai-entryresults.html',
                                                    className: 'ngdialog-theme-default ngdialog-theme-large',
                                                    scope: $scope
                                                })
                                            }
                                        }
                                    ]
                                }
                                
                                $scope.listenRun(r.id)

                                $scope.lastRun = r
                                if($scope.parentEntity){
                                    $scope.postProcessResultFormFn($scope.lastRun.id)
                                }
                            }
                            // for(let i=$scope.runs.length-1; i>=0; i--){
                            //     $scope.showRunResultsTableClick($scope.runs[i].id)
                            // }
                        })

                        $scope.entriesProgress = {};
                        $scope.maybeStuck = {}

                        $scope.checkStuck = function(key, unchanged){
                            if($scope.maybeStuck[key]!=null && $scope.maybeStuck[key]!==true && !unchanged){
                                $timeout.cancel($scope.maybeStuck[key])
                            }
                            $scope.maybeStuck[key] = $timeout(function(){
                                    if(($scope.process.files[key] && $scope.process.files[key].status == 'IMPORTING') || unchanged){
                                        $scope.maybeStuck[key] = true
                                    } else {
                                        $scope.maybeStuck[key] = null
                                    }
                                }, 120*1000)
                        }
                                    
                        let listenFile = function(key){
                            FIREBASE.listen('File', key, function(value){
                                if(value){
                                    $timeout(function(){
                                        $scope.process.files[key].rtUpdate = true
                                        $scope.process.files[key].status = value.status
                                        let unchanged = value.status=='IMPORTING' && $scope.entriesProgress[$scope.process.files[key].name] && $scope.entriesProgress[$scope.process.files[key].name].imported && $scope.entriesProgress[$scope.process.files[key].name].imported == value.imported
                                        $scope.entriesProgress[$scope.process.files[key].name] = value
                                        if($scope.entriesProgress[$scope.process.files[key].name].imported){
                                            $scope.fileImporting=true;
                                        }
                                        $scope.checkStuck(key, unchanged)
                                    }, 0)
                                    
                                }
                            }, null, { interval: 10000 })
                        }

                        if($scope.process.status=='IMPORTING'){
                            for(let key in $scope.process.files){
                                listenFile(key)
                            }
                        }

                        $scope.runProgress = {}

                        $scope.listenRun = function(runId){
                            FIREBASE.listen('QAiRun', runId, function(value){
                                if(value){
                                    let i = $scope.runs.findIndex(r => r.id==runId)
                                    if($scope.runs[i].status != value.status || value.forceReload>(new Date().getTime()-10000)){
                                        $scope.runStatuses[$scope.runs[i].status]--
                                        $scope.runs[i].status = value.status
                                        $scope.runStatuses[value.status] = $scope.runStatuses[value.status] ? $scope.runStatuses[value.status]+1 : 1
                                        $timeout(function(){
                                            //TODO: Put a loading indicator on the page
                                            D.load('qairun', runId).then(function(response){
                                                if($scope.runs[i].status != response.status){
                                                    $timeout(function(){
                                                        //TODO: Put a loading indicator on the page
                                                        D.load('qairun', runId).then(function(response){
                                                            response=$scope.cleanConditions(response);
                                                            $scope.runs[i] = response
                                                        })
                                                    }, 2000)
                                                }
                                                response=$scope.cleanConditions(response);
                                                $scope.runs[i] = response
                                            })
                                        }, 1000)
                                    }
                                    if(value.status=='POSTPROCESSING' && value.postProcessing){
                                        try{
                                            $timeout(function(){
                                                $scope.runs[i].opts.postProcess.find(f => f.name==value.postProcessing).progress = value.postProcessingProgress
                                            }, 1)
                                        }catch(e){}
                                    }
                                    if(value.entries>0){
                                        $timeout(function(){
                                            if(!$scope.runProgress[runId]) $scope.runProgress[runId] = {}
                                            $scope.runProgress[runId].processed = !$scope.runProgress[runId].processed || value.processed > $scope.runProgress[runId].processed ? value.processed : $scope.runProgress[runId].processed
                                            $scope.runProgress[runId].entries = value.entries
                                        }, 0)
                                    }
                                    if(value.estimatedCost){
                                        $timeout(function(){
                                            $scope.runs[i].estimatedCost = value.estimatedCost
                                            $scope.runs[i].estimatedTokens = value.estimatedTokens;
                                            $scope.estimatingCost = null
                                        },0)
                                    }
                                    if(value.error){
                                        $timeout(function(){
                                            $scope.runProgress[runId] = value.error
                                        }, 0)
                                    }
                                }
                            }, null, { interval: 10000 })
                        }

                        $scope.editTitleForm = {
                            title: '',
                            status: '',
                            type: 'qaiprocess',
                            model: $scope.process,
                            successLabel: 'labels.SUCCESSSAVE',
                            fields: [
                                        {
                                            available: true,
                                            name: 'name',
                                            type: 'text',
                                            required: true,
                                            placeholder: 'Nome univoco del processo',
                                            label: 'labels.INSERTNEWNAME'
                                        },{
                                            available: true,
                                            type: 'separator'
                                        },{
                                            available: true,
                                            type: 'submit',
                                            name: 'empty',
                                            label: 'labels.SAVE'
                                        }

                            ],
                            validate: function(){
                                var errors = [];
                                    for(var j=0; j<this.fields.length; j++){
                                        var field = this.fields[j];
                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                            errors.push({field:field,error:'required'});
                                        }
                                    }

                                if(errors.length) {
                                    var errorMessages ="<ul>";
                                    for(var i=0; i<errors.length; i++){
                                        var e = errors[i];
                                        errorMessages += "<li>"
                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                            +"</li>";
                                    }
                                    errorMessages += "</ul>";
                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    return false;
                                }
                                else return true;
                            },
                            submit: function(){
                                if(this.validate()){
                                    $scope.editTitleForm.status = 'submitting';
                                            D.save('qaiprocess', {id: $scope.process.id, action: 'EditProcessTitle', newTitle: this.model.name}).then(function(response){
                                                $scope.editTitleForm.status = 'submitted'
                                                $state.go('app.entity', { action: 'process', type:'qai',filter:response.id })
                                            });
                                }
                            }
                        };

                        $scope.deleteProcessForm = {
                            title: '',
                            status: '',
                            type: 'qaiprocess',
                            model: $scope.process,
                            successLabel: 'labels.SUCCESSSAVE',
                            fields: [
                                        {
                                            available: true,
                                            type: 'submit',
                                            name: 'empty',
                                            label: 'labels.DELETEPROCESS'
                                        }

                            ],
                            validate: function(){
                                var errors = [];
                                    for(var j=0; j<this.fields.length; j++){
                                        var field = this.fields[j];
                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                            errors.push({field:field,error:'required'});
                                        }
                                    }

                                if(errors.length) {
                                    var errorMessages ="<ul>";
                                    for(var i=0; i<errors.length; i++){
                                        var e = errors[i];
                                        errorMessages += "<li>"
                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                            +"</li>";
                                    }
                                    errorMessages += "</ul>";
                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    return false;
                                }
                                else return true;
                            },
                            submit: function(){
                                if(this.validate()){
                                    ngDialog.openConfirm({
                                        template: '/app/views/entities/qai-confirmdelete.html',
                                        className: 'ngdialog-theme-default',
                                        scope: $scope
                                      }).then(function (value) {
                                        $scope.deleteProcessForm.status = 'submitting';
                                        D.save('qaiprocess', {id: $scope.process.id, action: 'DeleteProcess'}).then(function(response){
                                            $scope.deleteProcessForm.status = 'submitted'
                                            $state.go('app.entity', { action: 'list', type:'qai', filter: 'own' });
                                        });
                                      });
                                    
                                }
                            }
                        };

//PROCESS FILES FORM
                        $scope.processFilesForm = {
                            title: 'labels.QAIPROCESSFILES',
                            status: 'notsubmittable',
                            type: 'qaiprocess',
                            model: $scope.process,
                            instructions: $scope.process.status=='INSERTED' ? $filter('translate')('labels.QAITMINSTRUCTIONS') : '',
                            instructionsLink: function(){
                                $scope.viewFile()
                            },
                            info: $scope.process.status=='INSERTED' ? $filter('translate')('labels.QAIPROCESSFILESINFO') : '',
                            refreshFile: function(data){
                                if($rootScope.files['qaiprocess'+this.model.id+'file'] && $rootScope.files['qaiprocess'+this.model.id+'file'].length>0 && this.status!='submitting')
                                    this.status = '';
                            },
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'file',
                                    required: true,
                                    canUpload: $scope.process.status=='INSERTED',
                                    cantDelete: $scope.process.status!='INSERTED',
                                    limit: -1,
                                    allow: 'mqxlz|mqxliff|xlsx|json|sdlxliff',
                                    noLabel:true,
                                    bucket: $rootScope.bucketName($scope.process.client),
                                    filesSelectable: $rootScope.user.admin,
                                    selectionActions: [
                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                    ] 
                                },
                                {
                                    available: $scope.process.status=='INSERTED',
                                    type: 'submit',
                                    noLabel: true,
                                    label: 'labels.QAICONFIRMANDIMPORT'
                                }
                            ],
                            submit: function(){
                                $scope.processFilesForm.status = 'submitting'
                                $scope.process.action = 'ImportQAiFiles'
                                $scope.processFilesForm.fields[0].canUpload = false
                                $scope.processFilesForm.fields[0].cantDelete = true
                                
                                D.save('qaiprocess', $scope.process).then(function(response){
                                    $scope.setActiveTab(1)
                                    let totalEntries = 0;
                                    $timeout(function(){
                                    for (let key in response.files) {
                                        totalEntries += response.files[key].entries;
                                        listenFile(key)
                                    }
                                }, 1000)
                                    $scope.processFilesForm.status = 'submitted'
                                    $scope.processFilesForm.info = ''
                                    $scope.process = response;
                                })
                            }
                        }

                        
                    
//ENTRIES TABLE
                        $scope.initEntriesTable = function(){
                            let fileOptions = []
                            for(let k in $scope.process.files){
                                fileOptions.push({ value: k, label: Object.keys($scope.process.files).indexOf(k) + 1 })
                            }

                            $scope.entriesTable = {
                                type: 'qaientry',
                                baseFilter: 'process=' + processId,
                                includedFields: ['id','file','attributes', 'customFields', 'sourceTerms', 'targetTerms'],
                                filter: true,
                                loadCallback: function(tableScope){
                                    for(let i=0; i<tableScope.data.length; i++){
                                        tableScope.data[i].fromFile = Object.keys($scope.process.files).indexOf(tableScope.data[i].file) + 1
                                        tableScope.data[i].filename = $scope.process.files[tableScope.data[i].file] ? $scope.process.files[tableScope.data[i].file].name  : ''
                                        if(tableScope.data[i].attributes && tableScope.data[i].attributes['mq:percent']!==undefined){
                                            tableScope.data[i].mqpercent = tableScope.data[i].attributes['mq:percent']
                                            tableScope.table.fields.find(f => f.name=='mqpercent').available = true
                                        }
                                    }
                                },
                                fields: [
                                    {
                                        available: Object.keys($scope.process.files).length>1,
                                        name: 'file',
                                        type: 'icon',
                                        icon: 'aqi-file aqi-2x',
                                        iconSuffix: {
                                            field: 'fromFile',
                                            style: {     
                                                left: '-32px',
                                                position: 'relative',
                                                top: '-4px',
                                                'font-size': '11px',
                                                display: 'inline-block',
                                                width: '28px',
                                                'text-align': 'center'
                                            }
                                        },
                                        iconTooltipField: 'filename',
                                        filterType: 'select',
                                        filterOptions: fileOptions
                                    },
                                    {
                                        available: true,
                                        name: 'unitId',
                                        filterType: 'text'
                                    },{
                                        available: true,
                                        name: 'source'
                                    },{
                                        available: true,
                                        name: 'target'
                                    },{
                                        available: true,
                                        name: 'isLocked',
                                        type: 'icon',
                                        icon: 'aqi-private'
                                    },{
                                        available: true,
                                        name: 'isMT',
                                        type: 'icon',
                                        icon: 'aqi-ai-model'
                                    },{
                                        available: false,
                                        name: 'mqpercent'
                                    },{
                                        available: true,
                                        name: 'viewResults',
                                        type: 'click',
                                        noLabel: true,
                                        icon: 'aqi-action-show-more',
                                        buttonClass: 'btn-xs',
                                        condition: function(m){ return $scope.process.status=='COMPLETED' },
                                        onclick: function(m){
                                            $scope.entry = m
                                            D.query('qairesult','entry=' + m.id).then(function(response){
                                                $scope.entryResults = response
                                            })
                                            D.load('qaientry', m.id).then(function(entry){
                                                $scope.entry.xml = entry.xml
                                            })
                                            ngDialog.open({
                                                template: '/app/views/entities/qai-entryresults.html',
                                                className: 'ngdialog-theme-default ngdialog-theme-large',
                                                scope: $scope
                                            })
                                        }
                                    }
                                ]
                            }
                        }

                        $scope.initEntriesTable()

                        
                        $scope.loadTermFiles()

                    })

                    

//CARICAMENTO PROMPT
                    D.query('qaiprompt', $rootScope.user.superUser ? 'enabled=true' : 'draft=false&enabled=true').then(function(response){
                        let typeOptions = []
                        let prompts = {}
                        let promptsMap = {}
                        for(let i=0; i<response.length; i++){
                            let p = response[i];
                            if(typeOptions.filter(o => o.value==p.answerType).length==0 && p.answerType!='INSTRUCTION'){
                                typeOptions.push({ value: p.answerType, label: $filter('translate')('enums.qaiType.'+p.answerType) })
                            }
                            if(!prompts[p.answerType]) prompts[p.answerType] = []
                            prompts[p.answerType].push(p)
                            promptsMap[p.id] = p
                        }
//NEW RUN FORM     
                        $scope.addConditionFormFn = function(form, option){
                            let fields = []
                            switch(option.value){
                                case 'rating': 
                                    fields = [{
                                        available: true,
                                        type: 'select',
                                        name: 'operator',
                                        valueField: 'value',
                                        labelField: 'label',
                                        data: [
                                            { value: '>=', label: '≥'},
                                            { value: '>', label: '﹥'},
                                            { value: '=', label: '='},
                                            { value: '<', label: '﹤'},
                                            { value: '<=', label: '≤'},
                                            { value: '≠', label: '≠'}
                                        ],
                                        required: true
                                    },{
                                        available: true,
                                        type: 'text',
                                        name: 'value',
                                        label: 'fields.RATING',
                                        required: true
                                    }]
                                    break;
                                case 'boolean': 
                                    fields = [{
                                        available: true,
                                        type: 'select',
                                        name: 'value',
                                        valueField: 'value',
                                        labelField: 'label',
                                        data: [
                                            { value: 'true', label: $filter('translate')('enums.boolean.TRUE') },
                                            { value: 'false', label: $filter('translate')('enums.boolean.FALSE') }
                                        ]
                                    }]
                                    break;
                                case 'hasTerms': 
                                    fields = [{
                                        available: true,
                                        type: 'select',
                                        name: 'value',
                                        valueField: 'value',
                                        labelField: 'label',
                                        data: [
                                            { value: 'true', label: $filter('translate')('enums.boolean.TRUE') },
                                            { value: 'false', label: $filter('translate')('enums.boolean.FALSE') }
                                        ]
                                    }]
                                    break;
                                case 'minNumOfWords':
                                    fields = [{
                                        available: true,
                                        type: 'number',
                                        name: 'value',
                                        required:true,
                                        label: 'fields.CONDITIONMINNUMOFWORDS',
                                        postfix: $filter('translate')('fields.NUMOFWORDS')
                                    }]
                                    break;
                                case 'hasContentInRun':
                                case 'hasErrorInRun':
                                    fields = [{
                                        available: true,
                                        type: 'select',
                                        name: 'value',
                                        required:true,
                                        valueField: 'id',
                                        labelField: 'name',
                                        label: 'fields.CONDITION' + option.value.toUpperCase(),
                                        data: $scope.runs
                                    }]
                                    break;
                                case 'unitIds':
                                    fields = [{
                                        available: true,
                                        type: 'textarea',
                                        name: 'value',
                                        required:true,
                                        label: 'fields.CONDITIONUNITIDS'
                                    }]
                                    break;
                                case 'mqOptions': 
                                    fields = [{
                                        available: true,
                                        type: 'select',
                                        name: 'mqOption',
                                        valueField: 'value',
                                        labelField: 'label',
                                        data: [
                                            { value: 'mqPercent', label: 'mq:percent'},
                                            { value: 'mqLocked', label: 'mq:locked'}
                                        ],
                                        required: true,
                                        onchange: function(model){
                                            if($scope.addConditionForm.model.mqOption=='mqLocked'){
                                                $scope.addConditionForm.fields[1].available = false;
                                                $scope.addConditionForm.fields[1].required = false;
                                                $scope.addConditionForm.fields[2].available = false;
                                                $scope.addConditionForm.fields[2].required = false;
                                                $scope.addConditionForm.fields[3].available = true;
                                                $scope.addConditionForm.fields[3].required = true;
                                            }else if($scope.addConditionForm.model.mqOption=='mqPercent'){
                                                $scope.addConditionForm.fields[1].available = true;
                                                $scope.addConditionForm.fields[1].required = true;
                                                $scope.addConditionForm.fields[2].available = true;
                                                $scope.addConditionForm.fields[2].required = true;
                                                $scope.addConditionForm.fields[3].available = false;
                                                $scope.addConditionForm.fields[3].required = false;
                                            }
                                        }
                                    },{
                                        available: false,
                                        type: 'number',
                                        name: 'fromValue',
                                        label: 'fields.FROMVALUE',
                                        required: false
                                    },{
                                        available: false,
                                        type: 'number',
                                        name: 'toValue',
                                        label: 'fields.TOVALUE',
                                        required: false
                                    },{
                                        available: false,
                                        type: 'select',
                                        name: 'booleanValue',
                                        label: 'fields.BOOLEANVALUE',
                                        valueField: 'value',
                                        labelField: 'label',
                                        data: [{
                                            value: true,
                                            label: $filter('translate')('enums.boolean.TRUE')
                                        }, {
                                            value: false,
                                            label: $filter('translate')('enums.boolean.FALSE')
                                        }],
                                        required: false
                                    }]
                                    break;

                            }
                            fields.push({
                                available: true,
                                type: 'submit',
                                label: 'labels.ADD'
                            })
                            return {
                                title: 'labels.ADDCONDITION',
                                info: $filter('translate')(option.description),
                                model: { key: option.value },
                                fields: fields,
                                validate: function(){
                                    var errors = [];
                                        for(var j=0; j<this.fields.length; j++){
                                            var field = this.fields[j];
                                            if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                errors.push({field:field,error:'required'});
                                            }
                                        }
                                    if(errors.length) {
                                        var errorMessages ="<ul>";
                                        for(var i=0; i<errors.length; i++){
                                            var e = errors[i];
                                            errorMessages += "<li>"
                                                +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                +"</li>";
                                        }
                                        errorMessages += "</ul>";
                                        $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                        return false;
                                    }
                                    else return true;
                                },
                                submit: function(){
                                    if(this.validate()){
                                        //if(this.model.value!==undefined && this.model.value!==null && this.model.value!==''){
                                            if(!form.model.conditions) form.model.conditions = []
                                            this.model.questionText = this.model.question
                                            let v = this.model.value
                                            if(this.model.operator) v = this.fields.filter(f => f.name=='operator')[0].data.filter(o => o.value==this.model.operator)[0].label + this.model.value
                                            if(option.value=='hasContentInRun' || option.value=='hasErrorInRun') v = $scope.runs.find(r => r.id==v).name
                                            if(option.value=='boolean'){
                                                v = this.model.value=='true' ? $filter('translate')('enums.boolean.TRUE') : $filter('translate')('enums.boolean.FALSE')
                                            }
                                            if(option.value=='mqOptions'){
                                                if(this.model.fromValue !== undefined && this.model.fromValue !== null && this.model.toValue !== undefined && this.model.toValue !== null){
                                                    v = this.fields.filter(f => f.name=='mqOption')[0].data.filter(o => o.value==this.model.mqOption)[0].label + ' ' + $filter('translate')('labels.INCLUDEDBETWEENTHEVALUES') + ' '+ this.model.fromValue + ' - '+ this.model.toValue
                                                }else if(this.model.booleanValue !== undefined && this.model.booleanValue !== null){
                                                    v = this.fields.filter(f => f.name=='mqOption')[0].data.filter(o => o.value==this.model.mqOption)[0].label + ' ' + $filter('translate')('labels.EQUALSTO') + ' '+ this.model.booleanValue
                                                }
                                            }
                                            this.model.conditionText = $filter('translate')('labels.QAIONCONDITION'+option.value.toUpperCase(), { value: v })
                                            form.model.conditions.push(this.model)
                                            ngDialog.close()
                                        //}
                                    }
                                }
                            }
                        }

                        $scope.qaiModelCanReasoningEffort = false;

                        D.query('qaimodel','').then(function(response){
                            $scope.models = response;
                            let newRunFormModel = { process: processId, conditions: [], instructions: [] };
                            for(var i=0; i<response.length; i++){
                                var qaiModel = response[i];
                                if($scope.process.model == qaiModel.id && qaiModel.canReasoningEffort && qaiModel.canReasoningEffort!=null){
                                    $scope.qaiModelCanReasoningEffort = true;
                                    newRunFormModel = { process: processId, conditions: [], instructions: [], reasoningEffort: 'high' };
                                }
                            }

                            $scope.newRunForm = {
                                title: 'labels.QAIRUNFORM',
                                status: '',
                                type: 'qairun',
                                model: newRunFormModel,
                                fields: [
                                    {   
                                        available: true,
                                        type: 'switch',
                                        name: 'type',
                                        label: 'fields.QAIRUNTYPE',
                                        options: typeOptions,
                                        required: true,
                                        onchange: function(option){
                                            $scope.newRunForm.model.type = option.value;
                                            $scope.newRunForm.model.prompt = null;
                                            $scope.newRunForm.model.questionText = ''
                                            $scope.newRunForm.fields.find(f => f.name=='questionText').available = false
                                            $scope.newRunForm.fields.find(f => f.name=='prompt').options = prompts[option.value]
                                            $scope.newRunForm.fields.find(f => f.name=='embeddingModel').available = false
                                            if(option.value==='RATING'){
                                                $scope.newRunForm.fields.find(f => f.name=='conditions').options.find(c => c.value=='rating').available = false
                                                $scope.newRunForm.fields.find(f => f.name=='instructions').available = false
                                                $scope.newRunForm.fields.find(f => f.name=='termFiles').available = false
                                                $scope.newRunForm.fields.find(f => f.name=='addTermFiles').available = false
                                            }else{
                                                $scope.newRunForm.fields.find(f => f.name=='conditions').options.find(c => c.value=='rating').available = true
                                                $scope.newRunForm.fields.find(f => f.name=='instructions').available = true
                                                $scope.newRunForm.fields.find(f => f.name=='termFiles').available = false
                                                $scope.newRunForm.fields.find(f => f.name=='addTermFiles').available = false
                                                $scope.loadTermFiles()
                                            }
                                            if(option.value=='ELABORATION'){
                                                $scope.newRunForm.fields.find(f => f.name=='termFiles').available = true
                                                $scope.newRunForm.fields.find(f => f.name=='addTermFiles').available = true
                                                $scope.loadTermFiles()
                                            }
                                            if(option.value=='EMBEDDINGS'){
                                                $scope.newRunForm.fields.find(f => f.name=='conditions').options.find(c => c.value=='rating').available = false
                                                $scope.newRunForm.fields.find(f => f.name=='instructions').available = true
                                                $scope.newRunForm.fields.find(f => f.name=='embeddingModel').available = true
                                                $scope.newRunForm.fields.find(f => f.name=='embeddingModel').data = $scope.models && $scope.models.filter(m => m.subType=='embedding')
                                            }
                                        }
                                    },{
                                        available: true,
                                        type: 'radiowithcontent',
                                        name: 'prompt',
                                        label: 'fields.QUESTION',
                                        options: [],
                                        optionsMap: promptsMap,
                                        valueField: 'id',
                                        labelField: 'name',
                                        descriptionField: 'question',
                                        required: true,
                                        placeholder: $filter('translate')('labels.QAISELECTPROMPT'),
                                        listStyle: { width: '600px', whiteSpace: 'normal'},
                                        onselect: function(o){
                                            $scope.newRunForm.model.questionText = o.question
                                            $scope.newRunForm.fields.find(f => f.name=='questionText').available = true
                                            if(o.opts && (o.opts.withTermFiles || o.opts.action=='AssignTermsToEntry')){
                                                $scope.newRunForm.fields.find(f => f.name=='termFiles').available = true
                                                $scope.newRunForm.fields.find(f => f.name=='addTermFiles').available = true
                                            } else {
                                                $scope.newRunForm.fields.find(f => f.name=='termFiles').available = false
                                                $scope.newRunForm.fields.find(f => f.name=='addTermFiles').available = false
                                            }
                                        }
                                    },
                                    {
                                        available: false,
                                        type: 'static',
                                        name: 'questionText'
                                    },
                                    {
                                        available: false,
                                        type: 'addelements',
                                        name: 'instructions',
                                        elementLabelField: 'questionText',
                                        onadd: function(event){
                                            event.preventDefault();
                                            $scope.instructions = prompts['INSTRUCTION']
                                            $scope.addInstructionForm = $scope.addInstructionFormFn($scope.newRunForm)
                                            
                                            ngDialog.open({
                                                template: '/app/views/entities/qai-instruction.html',
                                                className: 'ngdialog-theme-default ngdialog-theme-large',
                                                scope: $scope
                                            })
                                        },
                                        onremove: function(index, element){
                                            $scope.newRunForm.model.instructions.splice(index,1)
                                        }
                                    },{
                                        available: false,
                                        type: 'checkboxes',
                                        name: 'termFiles',
                                        data: $scope.termFiles,
                                        valueField: 'id',
                                        labelField: 'name',
                                        required: true
                                    },{
                                        available: false,
                                        type: 'addelements',
                                        name: 'addTermFiles',
                                        onadd: function(event){
                                            event.preventDefault();
                                            $scope.popupForm = {
                                                title: 'fields.ADDTERMFILES',
                                                status: '',
                                                type: 'group',
                                                model: { id: $scope.process.client },
                                                fields: [
                                                    {
                                                        available: true,
                                                        type: 'file',
                                                        name: 'qaitermstemp',
                                                        limit: -1,
                                                        canUpload: true,
                                                        cantDelete: true,
                                                        allow: 'xls|xlsx',
                                                        noLabel: true,
                                                        bucket: $rootScope.bucketName($scope.process.client),
                                                        filesSelectable: $rootScope.user.admin,
                                                        selectionActions: [
                                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                                        ] 
                                                    },{
                                                        available: true,
                                                        type: 'submit'
                                                    }
                                                ],
                                                submit: function(){
                                                    $scope.popupForm.status = 'submitting'
                                                    D.query('file', 'type=GROUP&field=qaiTermsTemp&entityid=' + $scope.process.client).then(function(response){
                                                        if(response.length==0){
                                                            $scope.loadTermFiles()
                                                            $scope.popupForm.status = ''
                                                            ngDialog.close()
                                                        } else {
                                                            let importedTermFiles = 0
                                                            for(let i=0; i<response.length; i++){
                                                                FIREBASE.listen('File', response[i].id, function(value){
                                                                    if(value && value.status=='IMPORTED'){
                                                                        importedTermFiles++
                                                                        if(importedTermFiles==response.length){
                                                                            $scope.loadTermFiles()
                                                                            $scope.popupForm.status = ''
                                                                            ngDialog.close()
                                                                        }
                                                                    }
                                                                })
                                                            }
                                                        }                                                    
                                                    })
                                                
                                                }
                                            }
                                            ngDialog.open({
                                                template: '/app/views/entities/popup-form.html',
                                                className: 'ngdialog-theme-default ngdialog-theme-large',
                                                scope: $scope
                                            })
                                        }
                                    },{
                                        available: true,
                                        type: 'addelements',
                                        name: 'conditions',
                                        options: [
                                            { value: 'rating', label: 'labels.QAICONDITIONRATING', description: 'labels.QAICONDITIONRATINGDESC', available: true },
                                            { value: 'boolean', label: 'labels.QAICONDITIONBOOLEAN', description: 'labels.QAICONDITIONBOOLEANDESC', available: true },
                                            { value: 'minNumOfWords', label: 'labels.QAICONDITIONMINNUMOFWORDS', description: 'labels.QAICONDITIONMINNUMOFWORDSDESC', available: true },
                                            { value: 'hasTerms', label: 'labels.QAICONDITIONHASTERMS', description: 'labels.QAICONDITIONHASTERMSDESC', available: true },
                                            { value: 'hasContentInRun', label: 'labels.QAICONDITIONHASCONTENTINRUN', description: 'labels.QAICONDITIONHASCONTENTINRUNDESC', available: true },
                                            { value: 'hasErrorInRun', label: 'labels.QAICONDITIONHASERRORINRUN', description: 'labels.QAICONDITIONHASERRORINRUNDESC', available: true },
                                            { value: 'unitIds', label: 'labels.QAICONDITIONUNITIDS', description: 'labels.QAICONDITIONUNITIDSDESC', available: true },
                                            { value: 'mqOptions', label: 'labels.QAICONDITIONMQOPTIONS', description: 'labels.QAICONDITIONMQOPTIONSDESC', available: true }
                                        ],
                                        listStyle: { width: '600px', whiteSpace: 'normal'},
                                        elementLabelField: 'conditionText',
                                        onadd: function(event, option){
                                            event.preventDefault()
                                            $scope.addConditionForm = $scope.addConditionFormFn($scope.newRunForm, option)
                                            ngDialog.open({
                                                template: '/app/views/entities/qai-condition.html',
                                                className: 'ng-dialog-theme-default ngdialog-theme-large',
                                                scope: $scope
                                            })
                                        },
                                        onremove: function(index, element){
                                            $scope.newRunForm.model.conditions.splice(index,1)
                                        }
                                    },{
                                        available: false,
                                        type: 'select',
                                        name: 'embeddingModel',
                                        valueField: 'id',
                                        labelField: 'name',
                                        data: $scope.models && $scope.models.filter(m => m.subType=='embedding')
                                    },{
                                        available: $scope.qaiModelCanReasoningEffort,
                                        type: 'select',
                                        name: 'reasoningEffort',
                                        data: [
                                            { id: 'low', name: 'low' },
                                            { id: 'medium', name: 'medium' },
                                            { id: 'high', name: 'high' }
                                        ],
                                        valueField: 'id',
                                        labelField: 'name'
                                    },{
                                        available: true,
                                        type: 'button',
                                        name: 'preview',
                                        label: 'fields.EMPTY',
                                        btnLabel: 'fields.PREVIEWRUN',
                                        cls: 'btn-info',
                                        icon: 'aqi-preview',
                                        onClick: function(form, event){
                                            event.preventDefault()
                                            $scope.previewRunId = ''
                                            $scope.previewRun = {}
                                            ngDialog.open({
                                                template: '/app/views/entities/qai-previewrun.html',
                                                className: 'ngdialog-theme-default',
                                                scope: $scope
                                            })
                                            D.save('qairun', Object.assign({}, $scope.newRunForm.model, { previewRun: true, action: 'PreviewQAiRun' })).then(function(response){
                                                $scope.previewRunId = response.id
                                                let lfn = function(rid){
                                                    FIREBASE.listen('QAiRun', rid, function(value){
                                                        $timeout(function(){
                                                            $scope.previewRun[rid] = value
                                                        },0)
                                                    })
                                                }(response.id)
                                            })
                                        }
                                    },{
                                        available: true,
                                        type: 'separator'
                                    },
                                    {
                                        available: true,
                                        type: 'submit'
                                    }
                                ],
                                validate: function(){
                                    var errors = [];
                                        for(var j=0; j<this.fields.length; j++){
                                            var field = this.fields[j];
                                            if(field.available && field.required && !this.model[field.name] && this.model[field.name]!==false){
                                                errors.push({field:field,error:'required'});
                                            }
                                        }
                                    if(errors.length) {
                                        var errorMessages ="<ul>";
                                        for(var i=0; i<errors.length; i++){
                                            var e = errors[i];
                                            errorMessages += "<li>"
                                                +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                +"</li>";
                                        }
                                        errorMessages += "</ul>";
                                        $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                        return false;
                                    }
                                    else return true;
                                },
                                submit: function(){
                                    if(this.validate()){
                                        $scope.newRunForm.status = 'submitting'
                                        D.save('qairun', $scope.newRunForm.model).then(function(response){
                                            $scope.newRunForm.status = 'submitted'
                                            D.load('qairun', response.id).then(function(r){
                                                r=$scope.cleanConditions(r);
                                                $scope.runs.push(r)
                                                $scope.activeTab = response.id
                                                if($scope.runStatuses["CREATED"]>=0){
                                                    $scope.runStatuses["CREATED"]=$scope.runStatuses["CREATED"]+1
                                                }else{
                                                    $scope.runStatuses["CREATED"]=1
                                                }
                                                $scope.listenRun(response.id)
                                                if($scope.qaiModelCanReasoningEffort){
                                                    $scope.newRunForm.model = { process: processId, conditions: [], instructions: [], reasoningEffort: 'high' }
                                                }else{
                                                    $scope.newRunForm.model = { process: processId, conditions: [], instructions: [] }
                                                }
                                                $scope.newRunForm.status = ''
                                            
                                                if(r.opts.termFiles && r.opts.termFiles.length>0){
                                                    for(let j=0; j<r.opts.termFiles.length; j++){
                                                        D.load('file', r.opts.termFiles[j]).then(function(respTerm){
                                                            $timeout(function(){
                                                                if(!$scope.runTermsFiles[r.id]) $scope.runTermsFiles[r.id] = []
                                                                $scope.runTermsFiles[r.id].push(respTerm)
                                                            },0)
                                                        })
                                                    }
                                                }
                                            })
                                        })
                                    }
                                }
                            
                            }
                            if ($scope.qaiModelCanReasoningEffort){
                                $scope.newRunForm.reasoningEffort = 'high';
                            }
                        })


                    })

                    
//ESTIMATE COST
                    $scope.estimateCost = function(runId){
                        $scope.estimatingCost = runId
                        D.save('qairun', { id: runId, action: 'EstimateQAiRunCost' }).then(function(response){
                            //risposta gestita da listenRun
                        })
                    }
//START RUN
                    $scope.startRun = function(runId){
                        $scope.resultGeneration = null
                        let i = $scope.runs.findIndex(r => r.id==runId)
                        $scope.runs[i].running = true
                        D.save('qairun', { id: runId, action: 'StartQAiRun', isBatch: $scope.runs[i].isBatch }).then(function(response){
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            D.load('qairun', runId).then(function(r){
                                r=$scope.cleanConditions(r);
                                $scope.runs[i] = r
                            })
                        })
                    }
//RESET RUN
                    $scope.resetRun = function(runId){
                        ngDialog.openConfirm({
                            template: '/app/views/entities/confirm.html',
                            className: 'ngdialog-theme-default',
                            scope: $scope
                          }).then(function (value) {
                                D.save('qairun', { id: runId, action: 'ResetQAiRun' }).then(function(response){
                                    $window.location.reload()
                                })
                          })
                    }
//DELETE RUN
                    $scope.deleteRun = function(runId){
                        $scope.deletingAnalysis = true
                        D.remove('qairun', runId).then(function(response){
                            $scope.runStatuses['CREATED']--
                            $scope.runStatuses['RUNNING']--
                            $scope.runs.pop()
                            $scope.setActiveTab(100)
                            $scope.deletingAnalysis = false
                        })
                    }
//STOP RUN
                    $scope.stopRun = function(runId){
                        D.save('qairun', { id: runId, action: 'StopQAiRun' }).then(function(response){
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            if(!response.id){ $scope.runs[i].errors = [{ message: 'labels.QAIRUNSTOPERROR' }]}
                            D.load('qairun', runId).then(function(r){
                                r=$scope.cleanConditions(r);
                                $scope.runs[i] = r
                            })
                        }).catch(function(err){
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            $scope.runs[i].errors = [{ message: 'labels.QAIRUNSTOPERROR' }]
                        })
                    }

                    $scope.startPostProcess = function(runId, pp){
                        pp.running = true
                        D.save('qairun', { id: runId, action: 'PostProcessQAiRun', procedure: pp.name, title: pp.title }).then(function(response){
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            D.load('qairun', runId).then(function(r){
                                r=$scope.cleanConditions(r);
                                $scope.runs[i] = r
                                $scope.listenRun(r.id)
                            })
                        }).catch(function(err){
                            pp.running = false
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            $scope.runs[i].errors = [{ message: 'labels.QAIRUNPOSTPROCESSERROR' }]
                        })
                    }

                    $scope.resetPostProcess = function(runId, procedure){
                        D.save('qairun', { id: runId, action: 'ResetPostProcessQAiRun', procedure: procedure }).then(function(response){
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            D.load('qairun', runId).then(function(r){
                                r=$scope.cleanConditions(r);
                                $scope.runs[i] = r
                            })
                        }).catch(function(err){
                            let i = $scope.runs.findIndex(r => r.id==runId)
                            $scope.runs[i].errors = [{ message: 'labels.QAIRUNPOSTPROCESSERROR' }]
                        })
                    }
//DOWNLOAD RESULTS
                    $scope.downloadResults = function(runId){
                        $scope.generatingResult = true
                        D.save('file', { process: $scope.process.id, action: 'GenerateQAiResultsFile', run: runId }).then(function(response){
                            $timeout(function(){
                                FIREBASE.listen('File', response.id, function(resp){
                                    if(resp){
                                        if(resp.status=='GENERATED'){
                                            $scope.generatingResult = false
                                            D.load('file', response.id).then(function(response){
                                                let a = document.createElement("a")
                                                a.href = response.url;
                                                a.download = response.name;
                                                document.body.appendChild(a);
                                                a.click();
                                                setTimeout(function() {
                                                    document.body.removeChild(a); 
                                                }, 0); 
                                                $scope.runResultsFiles[runId] = [response]
                                            })
                                            
                                            
                                        } else {
                                            $timeout(function(){
                                                $scope.resultGeneration = {
                                                    elements: resp.elements,
                                                    totalElements: resp.totalElements
                                                }
                                            },0)

                                        }
                                    }
                                
                                }, null, { interval: 10000 })
                            }, 1000)
                        })
                    }
//RETRY IMPORT
                    $scope.retryImport = function(key){
                        D.save('qaiprocess', {id:$scope.process.id , action: 'RetryImportQAiFile', file: key}).then(function(response){
                            $scope.checkStuck(key)
                        })
                    }

                    $scope.resetImport = function(){
                        $scope.resettingImport=true;
                        $scope.setActiveTab(0);
                        D.save('qaiprocess', {id: $scope.process.id, action: 'ResetImportFiles'}).then(function(response){
                            
                        })
                    }

                }
//END PROCESS PAGE

                if($state.params.action=='edittitle'){
                    
                }

//PROCESS LOG
                if($state.params.action=='log'){
                    $scope.timelineAlt = true
                    D.query('actionlog','entity=' + processId).then(function(response){
                        $scope.elements = []
                        for(var i=0; i<response.length; i++){
                            var e = response[i];
                            var data = angular.fromJson(e.data);
                            $scope.elements.push({
                                datetime: e.T,
                                action: e.action,
                                title: $filter('translate')('enums.useraction.'+e.action),
                                content: $filter('translate')('enums.useraction.'+e.action+'_TEXT', angular.fromJson(e.data)),
                                data: data
                            });
                        }
                    })
                }

//CREATE PROCESS
                if($state.params.action=='create'){
                    D.query('qaimodel','').then(function(response){
                        $scope.models = response;
                        D.query('group','type=client', { cache: false }).then(
                            function(response){
                                $scope.clients = response;
//CREATE PROCESS FORM
                        $scope.newProcessForm = {
                            title: '',
                            status: '',
                            type: 'qaiprocess',
                            model: { model: $scope.models.filter(m => m.isDefault)[0].id },
                            fields: [
                                {
                                    available: true,
                                    name: 'name',
                                    type: 'text',
                                    required: true,
                                    placeholder: 'Nome univoco del processo'
                                },{
                                    available: true,
                                    type: 'textarea',
                                    name: 'description'
                                },
                                {
                                    available: true,
                                    type: 'language',
                                    name: 'sourceLang',
                                    label: 'fields.SOURCE',
                                    placeholder: 'labels.SELECTLANGUAGE',
                                    required: true,
                                },
                                {
                                    available: true,
                                    type: 'language',
                                    name: 'targetLang',
                                    label: 'fields.TARGET',
                                    placeholder: 'labels.SELECTLANGUAGE',
                                    required: true,
                                },
                                {
                                    available: true,
                                    required: true,
                                    type: 'select',
                                    name: 'client',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $rootScope.clients
                                },{
                                    available: true,
                                    type: 'select',
                                    name: 'model',
                                    label: 'fields.QAIMODEL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.models && $scope.models.filter(m => !m.subType && m.enabled)
                                },
                                {
                                    available: true,
                                    type: 'select',
                                    required: true,
                                    name: 'mailNotificationWanted',
                                    label: 'fields.NOTIFICATIONFORM',
                                    disabled: false,
                                    valueField: 'value',
                                    labelField: 'label',
                                    data: [{
                                        value: 'true',
                                        label: $filter('translate')('labels.MAILNOTIFICATIONSACTIVE')
                                    }, {
                                        value: 'false',
                                        label: $filter('translate')('labels.MAILNOTIFICATIONSNOTACTIVE')
                                    }]
                                },
                                {
                                    available: true,
                                    type: 'submit'
                                }
                            ],
                            validate: function(){
                                var errors = [];
                                    for(var j=0; j<this.fields.length; j++){
                                        var field = this.fields[j];
                                        if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                            errors.push({field:field,error:'required'});
                                        }
                                    }
                                if(errors.length) {
                                    var errorMessages ="<ul>";
                                    for(var i=0; i<errors.length; i++){
                                        var e = errors[i];
                                        errorMessages += "<li>"
                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                            +"</li>";
                                    }
                                    errorMessages += "</ul>";
                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    return false;
                                }
                                else return true;
                            },
                            submit: function(){
                                if(this.validate()){
                                    $scope.newProcessForm.status = 'submitting'
                                    D.save('qaiprocess', $scope.newProcessForm.model).then(function(response){
                                        $scope.newProcessForm.status = 'submitted'
                                        $state.go('app.entity', { action: 'process', type:'qai',filter:response.id })
                                    })
                                }
                            }
                    }
                    })
                      }
                ).catch(console.error);
                }
//BATCHES
                if($state.params.action=='batches') {
                    
                    $scope.page = {
                        title: 'labels.QAIBATCHES',
                        subTitle: '',
                    };

                    $scope.data = []

                    $scope.filter = $state.params.filter;
                    
                    $scope.running = false
                    if($scope.filter && $scope.filter.startsWith('running')){
                        $scope.filter = 'batchrunning=true'
                        $scope.running = true
                    } else {
                        $scope.filter = 'batchrunning=false'
                    }
        
                    $scope.initialized = false;
                    $scope.watchActivated = false;
                    $scope.init = function () {
                        if ($rootScope.user.id) {
                            $scope.initialized = true;
            
                            $scope.batchesTable = {
                                title: '',
                                filter: false,
                                baseFilter: $scope.filter+'&_withProcess=true&_batches=true',
                                includedFields: ['process','batches','processObj'],
                                cls: 'no-panel-table',
                                containerStyle: { 'min-height': '600px' },
                                loadCallback: function(tableScope){
                                    for(let i=0; i<tableScope.data.length; i++){
                                        let process = tableScope.data[i].processObj
                                        if(process){
                                            for(let k of Object.keys(process)){
                                                tableScope.data[i]['process'+k] = process[k]
                                            }
                                        }
                                        tableScope.data[i].batcheslist = ''
                                        for(let j=0; j<tableScope.data[i].batches.length; j++){
                                            let b = tableScope.data[i].batches[j]
                                            tableScope.data[i].batcheslist += 
                                                '<div class="batchlist">' 
                                                + (j+1) + '. ' 
                                                +  b.status.toUpperCase() 
                                                + (b.request_counts ? (' [ ' + b.request_counts.total + ' / ' + b.request_counts.completed + ' / ' + b.request_counts.failed + ' ]') : '')
                                                + '</div>'
                                        }
                                    }
                                },
                                fields: [
                                    {
                                        available: true,
                                        name: 'processname',
                                        hasLink: true
                                    },
                                    {
                                        available: true,
                                        name: 'name',
                                        label: 'QAIRUN',
                                        filterType: 'text',
                                        filterValue: '',
                                        orderable: true,
                                        style: {
                                            minWidth: '400px',
                                        },
                                    },{
                                        available: true,
                                        name: 'batcheslist',
                                        type: 'html'
                                    }
                                ],
                                link: {
                                    state: '',
                                    action: 'process',
                                    type: 'qai',
                                    filter: 'process',
                                },
                                loading: true,
                            };

                            $scope.batchesTable.type = 'qairun'
            
                        } else {
                            if (!$scope.watchActivated) {
                            $scope.watchActivated = true;
                            $rootScope.$watch('user.id', function () {
                                if (!$scope.initialized) {
                                $scope.init();
                                }
                            });
                            }
                        }
                    };
        
                    $scope.init();
        
                        
                    
                  }
//PROCESS LIST
                if ($state.params.action == 'list') {
                    $scope.type = 'qai';
                    $scope.filter = $state.params.filter;
                    $scope.fromProjectList = false
                    if($scope.filter && $scope.filter.startsWith('projectid=')) { 
                        $scope.fromProjectList = true 
                        D.load('project', $scope.filter.replace('projectid=','')).then(function(resp){
                            $scope.page.subTitle = resp.code
                        })
                    }
                    $scope.isOwn = false
                    if($scope.filter && $scope.filter.startsWith('own')){
                        $scope.filter = 'ownerName=' + $rootScope.user.id
                        $scope.isOwn = true
                    }
                    $scope.data = [];
        
                    $scope.page = {
                        title: 'sidebar.nav.PROCESSESLIST',
                        subTitle: '',
                    };
        
                    $scope.initialized = false;
                    $scope.watchActivated = false;
                    $scope.init = function () {
                        if ($rootScope.user.id) {
                            $scope.initialized = true;
            
                            $scope.table = {
                                title: '',
                                filter: !$scope.fromProjectList,
                                baseFilter: $scope.filter,
                                orderBy: 'code',
                                order: 'desc',
                                includedFields: ['id'],
                                cls: 'no-panel-table',
                                containerStyle: { 'min-height': '600px' },
                                fields: [
                                    {
                                    available: !$scope.fromProjectList,
                                    name: 'clientName',
                                    filterType: 'clients',
                                    filterValue: '',
                                    style: {
                                        minWidth: '180px',
                                        'white-space': 'nowrap',
                                    },
                                    },
                                    {
                                    available: true,
                                    hasLink: true,
                                    name: 'name',
                                    label: 'PROCESSNAME',
                                    filterType: 'text',
                                    filterValue: '',
                                    orderable: true,
                                    style: {
                                        minWidth: '400px',
                                    },
                                    },
                                    {
                                    available: true,
                                    hasLink: true,
                                    name: 'status',
                                    label: 'PROCESSSTATUS',
                                    type: 'enum',
                                    enumType: 'qaiProcessStatus',
                                    filterType: 'select',
                                    filterOptions: [
                                                    {value:'', label:''},
                                                    {value:"INSERTED", label:'enums.qaiProcessStatus.INSERTED'},
                                                    {value:"IMPORTING", label:'enums.qaiProcessStatus.IMPORTING'},
                                                    {value:"IMPORTED", label:'enums.qaiProcessStatus.IMPORTED'},
                                                    {value:"RUNNING", label:'enums.qaiProcessStatus.RUNNING'},
                                                    {value:"COMPLETED", label:'enums.qaiProcessStatus.COMPLETED'}
                                                    ],
                                    orderable: true,
                                    style: {
                                        minWidth: '200px',
                                    },
                                    },
                                    {
                                    available: true,
                                    name: 'sourceLang',
                                    type: 'enum',
                                    enumType: 'language',
                                    filterType: 'language',
                                    filterValue: '',
                                    style: {
                                        'min-width': '200px',
                                    },
                                    },
                                    {
                                    available: true,
                                    name: 'targetLang',
                                    type: 'enum',
                                    enumType: 'language',
                                    filterType: 'language',
                                    filterValue: '',
                                    style: {
                                        'min-width': '200px',
                                    },
                                    },{
                                        available: true,
                                        name: 'words',
                                        label: 'fields.TOTALWORDS',
                                        type: 'number'
                                    },
                                    {
                                        available: !$scope.isOwn,
                                        name: 'ownerName',
                                        filterType: 'admins',
                                        filterValue: '',
                                        style: {
                                            minWidth: '180px',
                                            'white-space': 'nowrap'
                                        }
                                    },
                                    {
                                        available: true,
                                        name: 'createdOn',
                                        type: 'date',
                                        filterType: 'date',
                                        filterValue: '',
                                        orderable: true,
                                        style: {
                                            'min-width': '200px'
                                        }
                                    },{
                                        available: true,
                                        name: 'model'
                                    }
                                ],
                                link: {
                                    state: '',
                                    action: 'process',
                                    type: 'qai',
                                    filter: 'id',
                                },
                                links: $scope.fromProjectList ? [
                                    
                                ] : [
                                    {
                                    link: {
                                        action: 'create',
                                        type: 'qai',
                                        filter: '',
                                    },
                                    label: 'labels.ADDNEWPROCESS',
                                    },{
                                        link: {
                                            action: 'batches',
                                            type: 'qai',
                                            filter: ''
                                        },
                                        label: 'labels.QAIBATCHES'
                                    }
                                ],
                                loading: true,
                            };
            
                            $scope.table.availableFields = $scope.table.fields.filter(
                            function (f) {
                                return f.available;
                            }
                            );
            
                            $scope.table.type = 'qaiprocess';
            
                            //$scope.load(50, '', 1);
                        } else {
                            if (!$scope.watchActivated) {
                            $scope.watchActivated = true;
                            $rootScope.$watch('user.id', function () {
                                if (!$scope.initialized) {
                                $scope.init();
                                }
                            });
                            }
                        }
                    };
        
                    $scope.init();
        
                    $scope.$on('$destroy', function iVeBeenDismissed() {
                        $scope.load = function () {};
                    });
                        
                    
                  }


                  if ($state.params.action == 'embeddings') {

                    $scope.page.title = 'labels.QAIEMBEDDINGS'

                    D.query('qaimodel', '').then(function(response){
                        $scope.models = response.filter(m => m.subType=='embedding')
                        $scope.otherModels = response.filter(m => m.subType!='embedding')

                        $scope.embeddingsForm = {
                            title: 'labels.QAICOMPARE',
                            status: '',
                            model: { action: 'CompareQAi'},
                            fields: [
                                {
                                    available: true,
                                    type: 'select',
                                    name: 'model',
                                    label: 'fields.QAIEMBEDDINGMODEL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.models
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'content1'
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'content2'
                                },
                                {
                                    available: true,
                                    type: 'language',
                                    name: 'language'
                                },
                                {
                                    available: true,
                                    type: 'select',
                                    name: 'othermodel',
                                    label: 'fields.QAIMEANINGMODEL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.otherModels
                                },
                                {
                                    available: true,
                                    type: 'submit'
                                }
                            ],
                            submit: function(){
                                $scope.embeddingsForm.status = 'submitting'
                                D.save('qaisimilarity', this.model).then(function(response){
                                    $scope.similarity = response
                                    $scope.embeddingsForm.status = 'submitted'
                                }).catch(function(err){
                                    $scope.embeddingsForm.status = 'error'
                                })
                            }
                        }
                    })

                  }
                
                
                  setTimeout(function() {

                  D.query('qaiprompt', ($rootScope.user.superUser ? 'enabled=true' : 'draft=false&enabled=true') + '&scope=SourceCompare').then(function(response){
                    let promptsMap = {}
                    for(let i=0; i<response.length; i++){
                        let p = response[i];

                        promptsMap[p.id] = p
                    }

                    if($scope.parentEntity){
                        $scope.qaiSourceCompareForm = {
                        status: 'notsubmittable',
                        type: 'qaiprocess',
                        model: { id: $scope.parentEntity.id.replace('-','')+'a', mqOption: 'mqPercent', conditions: []},
                        refreshFile: function(data){
                            if($rootScope.files['qaiprocess'+this.model.id+'file'] && $rootScope.files['qaiprocess'+this.model.id+'file'].length>0)
                                this.status = '';
                            else
                                this.status = 'notsubmittable';
                        },
                        successLabel: 'labels.SUCCESSSAVE',
                        fields: [
                            {
                                available: true,
                                type: 'file',
                                name: 'file',
                                canUpload: true,
                                limit: -1,
                                withLang: true,
                                sync: {
                                    upload: true,
                                    folder: 'sourceCompare',
                                    code: $scope.parentEntity.code
                                },
                                allow: 'mqxlz|mqxliff|xlsx',
                                noLabel:true,
                                bucket: $rootScope.bucketName($scope.parentEntity.group),
                                filesSelectable: $rootScope.user.admin,
                                selectionActions: [
                                    { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                ] 
                            },{
                                available: true,
                                type: 'radiowithcontent',
                                name: 'prompt',
                                label: 'fields.QUESTION',
                                options: promptsMap,
                                optionsMap: promptsMap,
                                valueField: 'id',
                                labelField: 'name',
                                descriptionField: 'question',
                                required: true,
                                placeholder: $filter('translate')('labels.QAISELECTPROMPT'),
                                listStyle: { width: '600px', whiteSpace: 'normal'}
                            },
                            {   available: true, type: 'separator', noSpace: true },
                            {
                                available: true,
                                type: 'static',
                                name: 'mqOption',
                                withValue: true
                            },{
                                available: true,
                                type: 'number',
                                name: 'fromValue',
                                label: 'fields.FROMVALUE',
                                column: 6,
                                required: true
                            },{
                                available: true,
                                type: 'number',
                                name: 'toValue',
                                label: 'fields.TOVALUE',
                                column: 6,
                                required: true
                            },{
                                available: true,
                                type: 'submit',
                                name: 'empty',
                                label: 'labels.QAISTARTRUN',
                                labelColumn: 0
                            }
                        ],
                        validate: function(){
                            var errors = [];
                                for(var j=0; j<this.fields.length; j++){
                                    var field = this.fields[j];
                                    if(field.required && !this.model[field.name] && this.model[field.name]!==false){
                                        errors.push({field:field,error:'required'});
                                    }
                                }
                            if(errors.length) {
                                var errorMessages ="<ul>";
                                for(var i=0; i<errors.length; i++){
                                    var e = errors[i];
                                    var fieldName = (e.field.label && e.field.label.trim() !== '') ? e.field.label.replace('fields.','') : e.field.name;
                                    errorMessages += "<li>"
                                        +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+fieldName.toUpperCase()) })
                                        +"</li>";
                                }
                                errorMessages += "</ul>";
                                $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                return false;
                            }
                            else return true;
                        },
                        submit: function(){
                            if(this.validate()){
                                $scope.confirmLabel = 'CONFIRMQAISOURCECOMPARE';
                                ngDialog.openConfirm({
                                    template: '/app/views/entities/confirm-withlabel.html',
                                    className: 'ngdialog-theme-default',
                                    scope: $scope
                                }).then(function (value) {
                                    let _this = $scope.qaiSourceCompareForm
                                    if(_this.model.mqOption && _this.model.fromValue && _this.model.toValue){
                                        _this.model.conditions.push({
                                            "key": "mqOptions",
                                            "value": _this.model.mqOption+"|"+_this.model.fromValue+"|"+_this.model.toValue
                                        });
                                    }
                                    _this.model.fromAnalysis = $scope.parentEntity.id;
                                    $scope.qaiSourceCompareForm.status = 'submitting';
                                    _this.model.id='';
                                    D.save('qaiprocess', _this.model).then(function(response){
                                        $scope.qaiSourceCompareForm.status = 'submitted';
                                        $scope.process = response;
                                    }).catch(function(err){
                                        $scope.qaiSourceCompareForm.status = 'error';
                                    })
                                })
                            }
                        }
                    }
                }

                $scope.creationForms ={
                    'qaiSourceCompare': $scope.qaiSourceCompareForm
                }


                $scope.postProcessResultForm = null
                
                $scope.postProcessResultFormFn = function(id){
                    if($scope.parentEntity){
                        $scope.postProcessResultForm = {
                            type: 'qairun',
                            model: {
                                id: id
                            },
                            fields: [
                                {
                                    available: true,
                                    type: 'file',
                                    name: 'postprocess',
                                    canUpload: false,
                                    cantDelete: true,
                                    sync: {
                                        download: true,
                                        folder: 'sourceCompare',
                                        doBackup: 'Backup',
                                        code: $scope.parentEntity ? $scope.parentEntity.code : ''
                                    },
                                    bucket: $scope.parentEntity ? $rootScope.bucketName($scope.parentEntity.group) : '',
                                    noLabel: true
                                }
                            ]
                        }
                    }
                }
                $scope.postProcessResultFormFn($scope.lastRun.id)
                
    })
}, 1000);


             }

         })

        $scope.viewRunEntries = function(run){
            $scope.popupTable = angular.copy($scope.entriesTable);
            if(run.opts.promptOptions && run.opts.promptOptions.entryType){
                $scope.popupTable.baseFilter += '&type=' + run.opts.promptOptions.entryType
            }
            ngDialog.open({
                template: '/app/views/entities/popup-table.html',
                className: 'ngdialog-theme-default ngdialog-theme-large',
                scope: $scope
            });
        }

        $scope.viewFileTerms = function(file){
            $scope.popupTable = {
                type: 'qaiterm',
                baseFilter: 'file=' + file.id,
                fields: [
                    {
                        available: true,
                        name: 'idx'
                    },{
                        available: true,
                        name: 'source'
                    },{
                        available: true,
                        name: 'target'
                    }
                ]
            }
            ngDialog.open({
                template: '/app/views/entities/popup-table.html',
                className: 'ngdialog-theme-default ngdialog-theme-large',
                scope: $scope
            });        
        }

     }
 ]);